[
  {
    "name": "Smileys & Emotion",
    "subGroups": [
      {
        "name": "face-smiling",
        "emojis": [
          { "code": "1F600", "name": "grinning face" },
          { "code": "1F603", "name": "grinning face with big eyes" },
          { "code": "1F604", "name": "grinning face with smiling eyes" },
          { "code": "1F601", "name": "beaming face with smiling eyes" },
          { "code": "1F606", "name": "grinning squinting face" },
          { "code": "1F605", "name": "grinning face with sweat" },
          { "code": "1F923", "name": "rolling on the floor laughing" },
          { "code": "1F602", "name": "face with tears of joy" },
          { "code": "1F642", "name": "slightly smiling face" },
          { "code": "1F643", "name": "upside-down face" },
          { "code": "1FAE0", "name": "melting face" },
          { "code": "1F609", "name": "winking face" },
          { "code": "1F60A", "name": "smiling face with smiling eyes" },
          { "code": "1F607", "name": "smiling face with halo" }
        ]
      },
      {
        "name": "face-affection",
        "emojis": [
          { "code": "1F970", "name": "smiling face with hearts" },
          { "code": "1F60D", "name": "smiling face with heart-eyes" },
          { "code": "1F929", "name": "star-struck" },
          { "code": "1F618", "name": "face blowing a kiss" },
          { "code": "1F617", "name": "kissing face" },
          { "code": "263A FE0F", "name": "smiling face" },
          { "code": "1F61A", "name": "kissing face with closed eyes" },
          { "code": "1F619", "name": "kissing face with smiling eyes" },
          { "code": "1F972", "name": "smiling face with tear" }
        ]
      },
      {
        "name": "face-tongue",
        "emojis": [
          { "code": "1F60B", "name": "face savoring food" },
          { "code": "1F61B", "name": "face with tongue" },
          { "code": "1F61C", "name": "winking face with tongue" },
          { "code": "1F92A", "name": "zany face" },
          { "code": "1F61D", "name": "squinting face with tongue" },
          { "code": "1F911", "name": "money-mouth face" }
        ]
      },
      {
        "name": "face-hand",
        "emojis": [
          { "code": "1F917", "name": "smiling face with open hands" },
          { "code": "1F92D", "name": "face with hand over mouth" },
          { "code": "1FAE2", "name": "face with open eyes and hand over mouth" },
          { "code": "1FAE3", "name": "face with peeking eye" },
          { "code": "1F92B", "name": "shushing face" },
          { "code": "1F914", "name": "thinking face" },
          { "code": "1FAE1", "name": "saluting face" }
        ]
      },
      {
        "name": "face-neutral-skeptical",
        "emojis": [
          { "code": "1F910", "name": "zipper-mouth face" },
          { "code": "1F928", "name": "face with raised eyebrow" },
          { "code": "1F610", "name": "neutral face" },
          { "code": "1F611", "name": "expressionless face" },
          { "code": "1F636", "name": "face without mouth" },
          { "code": "1FAE5", "name": "dotted line face" },
          { "code": "1F636 200D 1F32B FE0F", "name": "face in clouds" },
          { "code": "1F60F", "name": "smirking face" },
          { "code": "1F612", "name": "unamused face" },
          { "code": "1F644", "name": "face with rolling eyes" },
          { "code": "1F62C", "name": "grimacing face" },
          { "code": "1F62E 200D 1F4A8", "name": "face exhaling" },
          { "code": "1F925", "name": "lying face" },
          { "code": "1FAE8", "name": "shaking face" },
          { "code": "1F642 200D 2194 FE0F", "name": "head shaking horizontally" },
          { "code": "1F642 200D 2195 FE0F", "name": "head shaking vertically" }
        ]
      },
      {
        "name": "face-sleepy",
        "emojis": [
          { "code": "1F60C", "name": "relieved face" },
          { "code": "1F614", "name": "pensive face" },
          { "code": "1F62A", "name": "sleepy face" },
          { "code": "1F924", "name": "drooling face" },
          { "code": "1F634", "name": "sleeping face" },
          { "code": "1FAE9", "name": "face with bags under eyes" }
        ]
      },
      {
        "name": "face-unwell",
        "emojis": [
          { "code": "1F637", "name": "face with medical mask" },
          { "code": "1F912", "name": "face with thermometer" },
          { "code": "1F915", "name": "face with head-bandage" },
          { "code": "1F922", "name": "nauseated face" },
          { "code": "1F92E", "name": "face vomiting" },
          { "code": "1F927", "name": "sneezing face" },
          { "code": "1F975", "name": "hot face" },
          { "code": "1F976", "name": "cold face" },
          { "code": "1F974", "name": "woozy face" },
          { "code": "1F635", "name": "face with crossed-out eyes" },
          { "code": "1F635 200D 1F4AB", "name": "face with spiral eyes" },
          { "code": "1F92F", "name": "exploding head" }
        ]
      },
      {
        "name": "face-hat",
        "emojis": [
          { "code": "1F920", "name": "cowboy hat face" },
          { "code": "1F973", "name": "partying face" },
          { "code": "1F978", "name": "disguised face" }
        ]
      },
      {
        "name": "face-glasses",
        "emojis": [
          { "code": "1F60E", "name": "smiling face with sunglasses" },
          { "code": "1F913", "name": "nerd face" },
          { "code": "1F9D0", "name": "face with monocle" }
        ]
      },
      {
        "name": "face-concerned",
        "emojis": [
          { "code": "1F615", "name": "confused face" },
          { "code": "1FAE4", "name": "face with diagonal mouth" },
          { "code": "1F61F", "name": "worried face" },
          { "code": "1F641", "name": "slightly frowning face" },
          { "code": "2639 FE0F", "name": "frowning face" },
          { "code": "1F62E", "name": "face with open mouth" },
          { "code": "1F62F", "name": "hushed face" },
          { "code": "1F632", "name": "astonished face" },
          { "code": "1F633", "name": "flushed face" },
          { "code": "1FAEA", "name": "distorted face" },
          { "code": "1F97A", "name": "pleading face" },
          { "code": "1F979", "name": "face holding back tears" },
          { "code": "1F626", "name": "frowning face with open mouth" },
          { "code": "1F627", "name": "anguished face" },
          { "code": "1F628", "name": "fearful face" },
          { "code": "1F630", "name": "anxious face with sweat" },
          { "code": "1F625", "name": "sad but relieved face" },
          { "code": "1F622", "name": "crying face" },
          { "code": "1F62D", "name": "loudly crying face" },
          { "code": "1F631", "name": "face screaming in fear" },
          { "code": "1F616", "name": "confounded face" },
          { "code": "1F623", "name": "persevering face" },
          { "code": "1F61E", "name": "disappointed face" },
          { "code": "1F613", "name": "downcast face with sweat" },
          { "code": "1F629", "name": "weary face" },
          { "code": "1F62B", "name": "tired face" },
          { "code": "1F971", "name": "yawning face" }
        ]
      },
      {
        "name": "face-negative",
        "emojis": [
          { "code": "1F624", "name": "face with steam from nose" },
          { "code": "1F621", "name": "enraged face" },
          { "code": "1F620", "name": "angry face" },
          { "code": "1F92C", "name": "face with symbols on mouth" },
          { "code": "1F608", "name": "smiling face with horns" },
          { "code": "1F47F", "name": "angry face with horns" },
          { "code": "1F480", "name": "skull" },
          { "code": "2620 FE0F", "name": "skull and crossbones" }
        ]
      },
      {
        "name": "face-costume",
        "emojis": [
          { "code": "1F4A9", "name": "pile of poo" },
          { "code": "1F921", "name": "clown face" },
          { "code": "1F479", "name": "ogre" },
          { "code": "1F47A", "name": "goblin" },
          { "code": "1F47B", "name": "ghost" },
          { "code": "1F47D", "name": "alien" },
          { "code": "1F47E", "name": "alien monster" },
          { "code": "1F916", "name": "robot" }
        ]
      },
      {
        "name": "cat-face",
        "emojis": [
          { "code": "1F63A", "name": "grinning cat" },
          { "code": "1F638", "name": "grinning cat with smiling eyes" },
          { "code": "1F639", "name": "cat with tears of joy" },
          { "code": "1F63B", "name": "smiling cat with heart-eyes" },
          { "code": "1F63C", "name": "cat with wry smile" },
          { "code": "1F63D", "name": "kissing cat" },
          { "code": "1F640", "name": "weary cat" },
          { "code": "1F63F", "name": "crying cat" },
          { "code": "1F63E", "name": "pouting cat" }
        ]
      },
      {
        "name": "monkey-face",
        "emojis": [
          { "code": "1F648", "name": "see-no-evil monkey" },
          { "code": "1F649", "name": "hear-no-evil monkey" },
          { "code": "1F64A", "name": "speak-no-evil monkey" }
        ]
      },
      {
        "name": "heart",
        "emojis": [
          { "code": "1F48C", "name": "love letter" },
          { "code": "1F498", "name": "heart with arrow" },
          { "code": "1F49D", "name": "heart with ribbon" },
          { "code": "1F496", "name": "sparkling heart" },
          { "code": "1F497", "name": "growing heart" },
          { "code": "1F493", "name": "beating heart" },
          { "code": "1F49E", "name": "revolving hearts" },
          { "code": "1F495", "name": "two hearts" },
          { "code": "1F49F", "name": "heart decoration" },
          { "code": "2763 FE0F", "name": "heart exclamation" },
          { "code": "1F494", "name": "broken heart" },
          { "code": "2764 FE0F 200D 1F525", "name": "heart on fire" },
          { "code": "2764 FE0F 200D 1FA79", "name": "mending heart" },
          { "code": "2764 FE0F", "name": "red heart" },
          { "code": "1FA77", "name": "pink heart" },
          { "code": "1F9E1", "name": "orange heart" },
          { "code": "1F49B", "name": "yellow heart" },
          { "code": "1F49A", "name": "green heart" },
          { "code": "1F499", "name": "blue heart" },
          { "code": "1FA75", "name": "light blue heart" },
          { "code": "1F49C", "name": "purple heart" },
          { "code": "1F90E", "name": "brown heart" },
          { "code": "1F5A4", "name": "black heart" },
          { "code": "1FA76", "name": "grey heart" },
          { "code": "1F90D", "name": "white heart" }
        ]
      },
      {
        "name": "emotion",
        "emojis": [
          { "code": "1F48B", "name": "kiss mark" },
          { "code": "1F4AF", "name": "hundred points" },
          { "code": "1F4A2", "name": "anger symbol" },
          { "code": "1FAEF", "name": "fight cloud" },
          { "code": "1F4A5", "name": "collision" },
          { "code": "1F4AB", "name": "dizzy" },
          { "code": "1F4A6", "name": "sweat droplets" },
          { "code": "1F4A8", "name": "dashing away" },
          { "code": "1F573 FE0F", "name": "hole" },
          { "code": "1F4AC", "name": "speech balloon" },
          { "code": "1F441 FE0F 200D 1F5E8 FE0F", "name": "eye in speech bubble" },
          { "code": "1F5E8 FE0F", "name": "left speech bubble" },
          { "code": "1F5EF FE0F", "name": "right anger bubble" },
          { "code": "1F4AD", "name": "thought balloon" },
          { "code": "1F4A4", "name": "ZZZ" }
        ]
      }
    ]
  },
  {
    "name": "People & Body",
    "subGroups": [
      {
        "name": "hand-fingers-open",
        "emojis": [
          { "code": "1F44B", "name": "waving hand" },
          { "code": "1F91A", "name": "raised back of hand" },
          { "code": "1F590 FE0F", "name": "hand with fingers splayed" },
          { "code": "270B", "name": "raised hand" },
          { "code": "1F596", "name": "vulcan salute" },
          { "code": "1FAF1", "name": "rightwards hand" },
          { "code": "1FAF2", "name": "leftwards hand" },
          { "code": "1FAF3", "name": "palm down hand" },
          { "code": "1FAF4", "name": "palm up hand" },
          { "code": "1FAF7", "name": "leftwards pushing hand" },
          { "code": "1FAF8", "name": "rightwards pushing hand" }
        ]
      },
      {
        "name": "hand-fingers-partial",
        "emojis": [
          { "code": "1F44C", "name": "OK hand" },
          { "code": "1F90C", "name": "pinched fingers" },
          { "code": "1F90F", "name": "pinching hand" },
          { "code": "270C FE0F", "name": "victory hand" },
          { "code": "1F91E", "name": "crossed fingers" },
          { "code": "1FAF0", "name": "hand with index finger and thumb crossed" },
          { "code": "1F91F", "name": "love-you gesture" },
          { "code": "1F918", "name": "sign of the horns" },
          { "code": "1F919", "name": "call me hand" }
        ]
      },
      {
        "name": "hand-single-finger",
        "emojis": [
          { "code": "1F448", "name": "backhand index pointing left" },
          { "code": "1F449", "name": "backhand index pointing right" },
          { "code": "1F446", "name": "backhand index pointing up" },
          { "code": "1F595", "name": "middle finger" },
          { "code": "1F447", "name": "backhand index pointing down" },
          { "code": "261D FE0F", "name": "index pointing up" },
          { "code": "1FAF5", "name": "index pointing at the viewer" }
        ]
      },
      {
        "name": "hand-fingers-closed",
        "emojis": [
          { "code": "1F44D", "name": "thumbs up" },
          { "code": "1F44E", "name": "thumbs down" },
          { "code": "270A", "name": "raised fist" },
          { "code": "1F44A", "name": "oncoming fist" },
          { "code": "1F91B", "name": "left-facing fist" },
          { "code": "1F91C", "name": "right-facing fist" }
        ]
      },
      {
        "name": "hands",
        "emojis": [
          { "code": "1F44F", "name": "clapping hands" },
          { "code": "1F64C", "name": "raising hands" },
          { "code": "1FAF6", "name": "heart hands" },
          { "code": "1F450", "name": "open hands" },
          { "code": "1F932", "name": "palms up together" },
          { "code": "1F91D", "name": "handshake" },
          { "code": "1F64F", "name": "folded hands" }
        ]
      },
      {
        "name": "hand-prop",
        "emojis": [
          { "code": "270D FE0F", "name": "writing hand" },
          { "code": "1F485", "name": "nail polish" },
          { "code": "1F933", "name": "selfie" }
        ]
      },
      {
        "name": "body-parts",
        "emojis": [
          { "code": "1F4AA", "name": "flexed biceps" },
          { "code": "1F9BE", "name": "mechanical arm" },
          { "code": "1F9BF", "name": "mechanical leg" },
          { "code": "1F9B5", "name": "leg" },
          { "code": "1F9B6", "name": "foot" },
          { "code": "1F442", "name": "ear" },
          { "code": "1F9BB", "name": "ear with hearing aid" },
          { "code": "1F443", "name": "nose" },
          { "code": "1F9E0", "name": "brain" },
          { "code": "1FAC0", "name": "anatomical heart" },
          { "code": "1FAC1", "name": "lungs" },
          { "code": "1F9B7", "name": "tooth" },
          { "code": "1F9B4", "name": "bone" },
          { "code": "1F440", "name": "eyes" },
          { "code": "1F441 FE0F", "name": "eye" },
          { "code": "1F445", "name": "tongue" },
          { "code": "1F444", "name": "mouth" },
          { "code": "1FAE6", "name": "biting lip" }
        ]
      },
      {
        "name": "person",
        "emojis": [
          { "code": "1F476", "name": "baby" },
          { "code": "1F9D2", "name": "child" },
          { "code": "1F466", "name": "boy" },
          { "code": "1F467", "name": "girl" },
          { "code": "1F9D1", "name": "person" },
          { "code": "1F471", "name": "person: blond hair" },
          { "code": "1F468", "name": "man" },
          { "code": "1F9D4", "name": "person: beard" },
          { "code": "1F9D4 200D 2642 FE0F", "name": "man: beard" },
          { "code": "1F9D4 200D 2640 FE0F", "name": "woman: beard" },
          { "code": "1F468 200D 1F9B0", "name": "man: red hair" },
          { "code": "1F468 200D 1F9B1", "name": "man: curly hair" },
          { "code": "1F468 200D 1F9B3", "name": "man: white hair" },
          { "code": "1F468 200D 1F9B2", "name": "man: bald" },
          { "code": "1F469", "name": "woman" },
          { "code": "1F469 200D 1F9B0", "name": "woman: red hair" },
          { "code": "1F9D1 200D 1F9B0", "name": "person: red hair" },
          { "code": "1F469 200D 1F9B1", "name": "woman: curly hair" },
          { "code": "1F9D1 200D 1F9B1", "name": "person: curly hair" },
          { "code": "1F469 200D 1F9B3", "name": "woman: white hair" },
          { "code": "1F9D1 200D 1F9B3", "name": "person: white hair" },
          { "code": "1F469 200D 1F9B2", "name": "woman: bald" },
          { "code": "1F9D1 200D 1F9B2", "name": "person: bald" },
          { "code": "1F471 200D 2640 FE0F", "name": "woman: blond hair" },
          { "code": "1F471 200D 2642 FE0F", "name": "man: blond hair" },
          { "code": "1F9D3", "name": "older person" },
          { "code": "1F474", "name": "old man" },
          { "code": "1F475", "name": "old woman" }
        ]
      },
      {
        "name": "person-gesture",
        "emojis": [
          { "code": "1F64D", "name": "person frowning" },
          { "code": "1F64D 200D 2642 FE0F", "name": "man frowning" },
          { "code": "1F64D 200D 2640 FE0F", "name": "woman frowning" },
          { "code": "1F64E", "name": "person pouting" },
          { "code": "1F64E 200D 2642 FE0F", "name": "man pouting" },
          { "code": "1F64E 200D 2640 FE0F", "name": "woman pouting" },
          { "code": "1F645", "name": "person gesturing NO" },
          { "code": "1F645 200D 2642 FE0F", "name": "man gesturing NO" },
          { "code": "1F645 200D 2640 FE0F", "name": "woman gesturing NO" },
          { "code": "1F646", "name": "person gesturing OK" },
          { "code": "1F646 200D 2642 FE0F", "name": "man gesturing OK" },
          { "code": "1F646 200D 2640 FE0F", "name": "woman gesturing OK" },
          { "code": "1F481", "name": "person tipping hand" },
          { "code": "1F481 200D 2642 FE0F", "name": "man tipping hand" },
          { "code": "1F481 200D 2640 FE0F", "name": "woman tipping hand" },
          { "code": "1F64B", "name": "person raising hand" },
          { "code": "1F64B 200D 2642 FE0F", "name": "man raising hand" },
          { "code": "1F64B 200D 2640 FE0F", "name": "woman raising hand" },
          { "code": "1F9CF", "name": "deaf person" },
          { "code": "1F9CF 200D 2642 FE0F", "name": "deaf man" },
          { "code": "1F9CF 200D 2640 FE0F", "name": "deaf woman" },
          { "code": "1F647", "name": "person bowing" },
          { "code": "1F647 200D 2642 FE0F", "name": "man bowing" },
          { "code": "1F647 200D 2640 FE0F", "name": "woman bowing" },
          { "code": "1F926", "name": "person facepalming" },
          { "code": "1F926 200D 2642 FE0F", "name": "man facepalming" },
          { "code": "1F926 200D 2640 FE0F", "name": "woman facepalming" },
          { "code": "1F937", "name": "person shrugging" },
          { "code": "1F937 200D 2642 FE0F", "name": "man shrugging" },
          { "code": "1F937 200D 2640 FE0F", "name": "woman shrugging" }
        ]
      },
      {
        "name": "person-role",
        "emojis": [
          { "code": "1F9D1 200D 2695 FE0F", "name": "health worker" },
          { "code": "1F468 200D 2695 FE0F", "name": "man health worker" },
          { "code": "1F469 200D 2695 FE0F", "name": "woman health worker" },
          { "code": "1F9D1 200D 1F393", "name": "student" },
          { "code": "1F468 200D 1F393", "name": "man student" },
          { "code": "1F469 200D 1F393", "name": "woman student" },
          { "code": "1F9D1 200D 1F3EB", "name": "teacher" },
          { "code": "1F468 200D 1F3EB", "name": "man teacher" },
          { "code": "1F469 200D 1F3EB", "name": "woman teacher" },
          { "code": "1F9D1 200D 2696 FE0F", "name": "judge" },
          { "code": "1F468 200D 2696 FE0F", "name": "man judge" },
          { "code": "1F469 200D 2696 FE0F", "name": "woman judge" },
          { "code": "1F9D1 200D 1F33E", "name": "farmer" },
          { "code": "1F468 200D 1F33E", "name": "man farmer" },
          { "code": "1F469 200D 1F33E", "name": "woman farmer" },
          { "code": "1F9D1 200D 1F373", "name": "cook" },
          { "code": "1F468 200D 1F373", "name": "man cook" },
          { "code": "1F469 200D 1F373", "name": "woman cook" },
          { "code": "1F9D1 200D 1F527", "name": "mechanic" },
          { "code": "1F468 200D 1F527", "name": "man mechanic" },
          { "code": "1F469 200D 1F527", "name": "woman mechanic" },
          { "code": "1F9D1 200D 1F3ED", "name": "factory worker" },
          { "code": "1F468 200D 1F3ED", "name": "man factory worker" },
          { "code": "1F469 200D 1F3ED", "name": "woman factory worker" },
          { "code": "1F9D1 200D 1F4BC", "name": "office worker" },
          { "code": "1F468 200D 1F4BC", "name": "man office worker" },
          { "code": "1F469 200D 1F4BC", "name": "woman office worker" },
          { "code": "1F9D1 200D 1F52C", "name": "scientist" },
          { "code": "1F468 200D 1F52C", "name": "man scientist" },
          { "code": "1F469 200D 1F52C", "name": "woman scientist" },
          { "code": "1F9D1 200D 1F4BB", "name": "technologist" },
          { "code": "1F468 200D 1F4BB", "name": "man technologist" },
          { "code": "1F469 200D 1F4BB", "name": "woman technologist" },
          { "code": "1F9D1 200D 1F3A4", "name": "singer" },
          { "code": "1F468 200D 1F3A4", "name": "man singer" },
          { "code": "1F469 200D 1F3A4", "name": "woman singer" },
          { "code": "1F9D1 200D 1F3A8", "name": "artist" },
          { "code": "1F468 200D 1F3A8", "name": "man artist" },
          { "code": "1F469 200D 1F3A8", "name": "woman artist" },
          { "code": "1F9D1 200D 2708 FE0F", "name": "pilot" },
          { "code": "1F468 200D 2708 FE0F", "name": "man pilot" },
          { "code": "1F469 200D 2708 FE0F", "name": "woman pilot" },
          { "code": "1F9D1 200D 1F680", "name": "astronaut" },
          { "code": "1F468 200D 1F680", "name": "man astronaut" },
          { "code": "1F469 200D 1F680", "name": "woman astronaut" },
          { "code": "1F9D1 200D 1F692", "name": "firefighter" },
          { "code": "1F468 200D 1F692", "name": "man firefighter" },
          { "code": "1F469 200D 1F692", "name": "woman firefighter" },
          { "code": "1F46E", "name": "police officer" },
          { "code": "1F46E 200D 2642 FE0F", "name": "man police officer" },
          { "code": "1F46E 200D 2640 FE0F", "name": "woman police officer" },
          { "code": "1F575 FE0F", "name": "detective" },
          { "code": "1F575 FE0F 200D 2642 FE0F", "name": "man detective" },
          { "code": "1F575 FE0F 200D 2640 FE0F", "name": "woman detective" },
          { "code": "1F482", "name": "guard" },
          { "code": "1F482 200D 2642 FE0F", "name": "man guard" },
          { "code": "1F482 200D 2640 FE0F", "name": "woman guard" },
          { "code": "1F977", "name": "ninja" },
          { "code": "1F477", "name": "construction worker" },
          { "code": "1F477 200D 2642 FE0F", "name": "man construction worker" },
          { "code": "1F477 200D 2640 FE0F", "name": "woman construction worker" },
          { "code": "1FAC5", "name": "person with crown" },
          { "code": "1F934", "name": "prince" },
          { "code": "1F478", "name": "princess" },
          { "code": "1F473", "name": "person wearing turban" },
          { "code": "1F473 200D 2642 FE0F", "name": "man wearing turban" },
          { "code": "1F473 200D 2640 FE0F", "name": "woman wearing turban" },
          { "code": "1F472", "name": "person with skullcap" },
          { "code": "1F9D5", "name": "woman with headscarf" },
          { "code": "1F935", "name": "person in tuxedo" },
          { "code": "1F935 200D 2642 FE0F", "name": "man in tuxedo" },
          { "code": "1F935 200D 2640 FE0F", "name": "woman in tuxedo" },
          { "code": "1F470", "name": "person with veil" },
          { "code": "1F470 200D 2642 FE0F", "name": "man with veil" },
          { "code": "1F470 200D 2640 FE0F", "name": "woman with veil" },
          { "code": "1F930", "name": "pregnant woman" },
          { "code": "1FAC3", "name": "pregnant man" },
          { "code": "1FAC4", "name": "pregnant person" },
          { "code": "1F931", "name": "breast-feeding" },
          { "code": "1F469 200D 1F37C", "name": "woman feeding baby" },
          { "code": "1F468 200D 1F37C", "name": "man feeding baby" },
          { "code": "1F9D1 200D 1F37C", "name": "person feeding baby" }
        ]
      },
      {
        "name": "person-fantasy",
        "emojis": [
          { "code": "1F47C", "name": "baby angel" },
          { "code": "1F385", "name": "Santa Claus" },
          { "code": "1F936", "name": "Mrs. Claus" },
          { "code": "1F9D1 200D 1F384", "name": "Mx Claus" },
          { "code": "1F9B8", "name": "superhero" },
          { "code": "1F9B8 200D 2642 FE0F", "name": "man superhero" },
          { "code": "1F9B8 200D 2640 FE0F", "name": "woman superhero" },
          { "code": "1F9B9", "name": "supervillain" },
          { "code": "1F9B9 200D 2642 FE0F", "name": "man supervillain" },
          { "code": "1F9B9 200D 2640 FE0F", "name": "woman supervillain" },
          { "code": "1F9D9", "name": "mage" },
          { "code": "1F9D9 200D 2642 FE0F", "name": "man mage" },
          { "code": "1F9D9 200D 2640 FE0F", "name": "woman mage" },
          { "code": "1F9DA", "name": "fairy" },
          { "code": "1F9DA 200D 2642 FE0F", "name": "man fairy" },
          { "code": "1F9DA 200D 2640 FE0F", "name": "woman fairy" },
          { "code": "1F9DB", "name": "vampire" },
          { "code": "1F9DB 200D 2642 FE0F", "name": "man vampire" },
          { "code": "1F9DB 200D 2640 FE0F", "name": "woman vampire" },
          { "code": "1F9DC", "name": "merperson" },
          { "code": "1F9DC 200D 2642 FE0F", "name": "merman" },
          { "code": "1F9DC 200D 2640 FE0F", "name": "mermaid" },
          { "code": "1F9DD", "name": "elf" },
          { "code": "1F9DD 200D 2642 FE0F", "name": "man elf" },
          { "code": "1F9DD 200D 2640 FE0F", "name": "woman elf" },
          { "code": "1F9DE", "name": "genie" },
          { "code": "1F9DE 200D 2642 FE0F", "name": "man genie" },
          { "code": "1F9DE 200D 2640 FE0F", "name": "woman genie" },
          { "code": "1F9DF", "name": "zombie" },
          { "code": "1F9DF 200D 2642 FE0F", "name": "man zombie" },
          { "code": "1F9DF 200D 2640 FE0F", "name": "woman zombie" },
          { "code": "1F9CC", "name": "troll" },
          { "code": "1FAC8", "name": "hairy creature" }
        ]
      },
      {
        "name": "person-activity",
        "emojis": [
          { "code": "1F486", "name": "person getting massage" },
          { "code": "1F486 200D 2642 FE0F", "name": "man getting massage" },
          { "code": "1F486 200D 2640 FE0F", "name": "woman getting massage" },
          { "code": "1F487", "name": "person getting haircut" },
          { "code": "1F487 200D 2642 FE0F", "name": "man getting haircut" },
          { "code": "1F487 200D 2640 FE0F", "name": "woman getting haircut" },
          { "code": "1F6B6", "name": "person walking" },
          { "code": "1F6B6 200D 2642 FE0F", "name": "man walking" },
          { "code": "1F6B6 200D 2640 FE0F", "name": "woman walking" },
          { "code": "1F6B6 200D 27A1 FE0F", "name": "person walking facing right" },
          { "code": "1F6B6 200D 2640 FE0F 200D 27A1 FE0F", "name": "woman walking facing right" },
          { "code": "1F6B6 200D 2642 FE0F 200D 27A1 FE0F", "name": "man walking facing right" },
          { "code": "1F9CD", "name": "person standing" },
          { "code": "1F9CD 200D 2642 FE0F", "name": "man standing" },
          { "code": "1F9CD 200D 2640 FE0F", "name": "woman standing" },
          { "code": "1F9CE", "name": "person kneeling" },
          { "code": "1F9CE 200D 2642 FE0F", "name": "man kneeling" },
          { "code": "1F9CE 200D 2640 FE0F", "name": "woman kneeling" },
          { "code": "1F9CE 200D 27A1 FE0F", "name": "person kneeling facing right" },
          { "code": "1F9CE 200D 2640 FE0F 200D 27A1 FE0F", "name": "woman kneeling facing right" },
          { "code": "1F9CE 200D 2642 FE0F 200D 27A1 FE0F", "name": "man kneeling facing right" },
          { "code": "1F9D1 200D 1F9AF", "name": "person with white cane" },
          { "code": "1F9D1 200D 1F9AF 200D 27A1 FE0F", "name": "person with white cane facing right" },
          { "code": "1F468 200D 1F9AF", "name": "man with white cane" },
          { "code": "1F468 200D 1F9AF 200D 27A1 FE0F", "name": "man with white cane facing right" },
          { "code": "1F469 200D 1F9AF", "name": "woman with white cane" },
          { "code": "1F469 200D 1F9AF 200D 27A1 FE0F", "name": "woman with white cane facing right" },
          { "code": "1F9D1 200D 1F9BC", "name": "person in motorized wheelchair" },
          { "code": "1F9D1 200D 1F9BC 200D 27A1 FE0F", "name": "person in motorized wheelchair facing right" },
          { "code": "1F468 200D 1F9BC", "name": "man in motorized wheelchair" },
          { "code": "1F468 200D 1F9BC 200D 27A1 FE0F", "name": "man in motorized wheelchair facing right" },
          { "code": "1F469 200D 1F9BC", "name": "woman in motorized wheelchair" },
          { "code": "1F469 200D 1F9BC 200D 27A1 FE0F", "name": "woman in motorized wheelchair facing right" },
          { "code": "1F9D1 200D 1F9BD", "name": "person in manual wheelchair" },
          { "code": "1F9D1 200D 1F9BD 200D 27A1 FE0F", "name": "person in manual wheelchair facing right" },
          { "code": "1F468 200D 1F9BD", "name": "man in manual wheelchair" },
          { "code": "1F468 200D 1F9BD 200D 27A1 FE0F", "name": "man in manual wheelchair facing right" },
          { "code": "1F469 200D 1F9BD", "name": "woman in manual wheelchair" },
          { "code": "1F469 200D 1F9BD 200D 27A1 FE0F", "name": "woman in manual wheelchair facing right" },
          { "code": "1F3C3", "name": "person running" },
          { "code": "1F3C3 200D 2642 FE0F", "name": "man running" },
          { "code": "1F3C3 200D 2640 FE0F", "name": "woman running" },
          { "code": "1F3C3 200D 27A1 FE0F", "name": "person running facing right" },
          { "code": "1F3C3 200D 2640 FE0F 200D 27A1 FE0F", "name": "woman running facing right" },
          { "code": "1F3C3 200D 2642 FE0F 200D 27A1 FE0F", "name": "man running facing right" },
          { "code": "1F9D1 200D 1FA70", "name": "ballet dancer" },
          { "code": "1F483", "name": "woman dancing" },
          { "code": "1F57A", "name": "man dancing" },
          { "code": "1F574 FE0F", "name": "person in suit levitating" },
          { "code": "1F46F", "name": "people with bunny ears" },
          { "code": "1F46F 200D 2642 FE0F", "name": "men with bunny ears" },
          { "code": "1F46F 200D 2640 FE0F", "name": "women with bunny ears" },
          { "code": "1F9D6", "name": "person in steamy room" },
          { "code": "1F9D6 200D 2642 FE0F", "name": "man in steamy room" },
          { "code": "1F9D6 200D 2640 FE0F", "name": "woman in steamy room" },
          { "code": "1F9D7", "name": "person climbing" },
          { "code": "1F9D7 200D 2642 FE0F", "name": "man climbing" },
          { "code": "1F9D7 200D 2640 FE0F", "name": "woman climbing" }
        ]
      },
      {
        "name": "person-sport",
        "emojis": [
          { "code": "1F93A", "name": "person fencing" },
          { "code": "1F3C7", "name": "horse racing" },
          { "code": "26F7 FE0F", "name": "skier" },
          { "code": "1F3C2", "name": "snowboarder" },
          { "code": "1F3CC FE0F", "name": "person golfing" },
          { "code": "1F3CC FE0F 200D 2642 FE0F", "name": "man golfing" },
          { "code": "1F3CC FE0F 200D 2640 FE0F", "name": "woman golfing" },
          { "code": "1F3C4", "name": "person surfing" },
          { "code": "1F3C4 200D 2642 FE0F", "name": "man surfing" },
          { "code": "1F3C4 200D 2640 FE0F", "name": "woman surfing" },
          { "code": "1F6A3", "name": "person rowing boat" },
          { "code": "1F6A3 200D 2642 FE0F", "name": "man rowing boat" },
          { "code": "1F6A3 200D 2640 FE0F", "name": "woman rowing boat" },
          { "code": "1F3CA", "name": "person swimming" },
          { "code": "1F3CA 200D 2642 FE0F", "name": "man swimming" },
          { "code": "1F3CA 200D 2640 FE0F", "name": "woman swimming" },
          { "code": "26F9 FE0F", "name": "person bouncing ball" },
          { "code": "26F9 FE0F 200D 2642 FE0F", "name": "man bouncing ball" },
          { "code": "26F9 FE0F 200D 2640 FE0F", "name": "woman bouncing ball" },
          { "code": "1F3CB FE0F", "name": "person lifting weights" },
          { "code": "1F3CB FE0F 200D 2642 FE0F", "name": "man lifting weights" },
          { "code": "1F3CB FE0F 200D 2640 FE0F", "name": "woman lifting weights" },
          { "code": "1F6B4", "name": "person biking" },
          { "code": "1F6B4 200D 2642 FE0F", "name": "man biking" },
          { "code": "1F6B4 200D 2640 FE0F", "name": "woman biking" },
          { "code": "1F6B5", "name": "person mountain biking" },
          { "code": "1F6B5 200D 2642 FE0F", "name": "man mountain biking" },
          { "code": "1F6B5 200D 2640 FE0F", "name": "woman mountain biking" },
          { "code": "1F938", "name": "person cartwheeling" },
          { "code": "1F938 200D 2642 FE0F", "name": "man cartwheeling" },
          { "code": "1F938 200D 2640 FE0F", "name": "woman cartwheeling" },
          { "code": "1F93C", "name": "people wrestling" },
          { "code": "1F93C 200D 2642 FE0F", "name": "men wrestling" },
          { "code": "1F93C 200D 2640 FE0F", "name": "women wrestling" },
          { "code": "1F93D", "name": "person playing water polo" },
          { "code": "1F93D 200D 2642 FE0F", "name": "man playing water polo" },
          { "code": "1F93D 200D 2640 FE0F", "name": "woman playing water polo" },
          { "code": "1F93E", "name": "person playing handball" },
          { "code": "1F93E 200D 2642 FE0F", "name": "man playing handball" },
          { "code": "1F93E 200D 2640 FE0F", "name": "woman playing handball" },
          { "code": "1F939", "name": "person juggling" },
          { "code": "1F939 200D 2642 FE0F", "name": "man juggling" },
          { "code": "1F939 200D 2640 FE0F", "name": "woman juggling" }
        ]
      },
      {
        "name": "person-resting",
        "emojis": [
          { "code": "1F9D8", "name": "person in lotus position" },
          { "code": "1F9D8 200D 2642 FE0F", "name": "man in lotus position" },
          { "code": "1F9D8 200D 2640 FE0F", "name": "woman in lotus position" },
          { "code": "1F6C0", "name": "person taking bath" },
          { "code": "1F6CC", "name": "person in bed" }
        ]
      },
      {
        "name": "family",
        "emojis": [
          { "code": "1F9D1 200D 1F91D 200D 1F9D1", "name": "people holding hands" },
          { "code": "1F46D", "name": "women holding hands" },
          { "code": "1F46B", "name": "woman and man holding hands" },
          { "code": "1F46C", "name": "men holding hands" },
          { "code": "1F48F", "name": "kiss" },
          { "code": "1F469 200D 2764 FE0F 200D 1F48B 200D 1F468", "name": "kiss: woman, man" },
          { "code": "1F468 200D 2764 FE0F 200D 1F48B 200D 1F468", "name": "kiss: man, man" },
          { "code": "1F469 200D 2764 FE0F 200D 1F48B 200D 1F469", "name": "kiss: woman, woman" },
          { "code": "1F491", "name": "couple with heart" },
          { "code": "1F469 200D 2764 FE0F 200D 1F468", "name": "couple with heart: woman, man" },
          { "code": "1F468 200D 2764 FE0F 200D 1F468", "name": "couple with heart: man, man" },
          { "code": "1F469 200D 2764 FE0F 200D 1F469", "name": "couple with heart: woman, woman" },
          { "code": "1F468 200D 1F469 200D 1F466", "name": "family: man, woman, boy" },
          { "code": "1F468 200D 1F469 200D 1F467", "name": "family: man, woman, girl" },
          { "code": "1F468 200D 1F469 200D 1F467 200D 1F466", "name": "family: man, woman, girl, boy" },
          { "code": "1F468 200D 1F469 200D 1F466 200D 1F466", "name": "family: man, woman, boy, boy" },
          { "code": "1F468 200D 1F469 200D 1F467 200D 1F467", "name": "family: man, woman, girl, girl" },
          { "code": "1F468 200D 1F468 200D 1F466", "name": "family: man, man, boy" },
          { "code": "1F468 200D 1F468 200D 1F467", "name": "family: man, man, girl" },
          { "code": "1F468 200D 1F468 200D 1F467 200D 1F466", "name": "family: man, man, girl, boy" },
          { "code": "1F468 200D 1F468 200D 1F466 200D 1F466", "name": "family: man, man, boy, boy" },
          { "code": "1F468 200D 1F468 200D 1F467 200D 1F467", "name": "family: man, man, girl, girl" },
          { "code": "1F469 200D 1F469 200D 1F466", "name": "family: woman, woman, boy" },
          { "code": "1F469 200D 1F469 200D 1F467", "name": "family: woman, woman, girl" },
          { "code": "1F469 200D 1F469 200D 1F467 200D 1F466", "name": "family: woman, woman, girl, boy" },
          { "code": "1F469 200D 1F469 200D 1F466 200D 1F466", "name": "family: woman, woman, boy, boy" },
          { "code": "1F469 200D 1F469 200D 1F467 200D 1F467", "name": "family: woman, woman, girl, girl" },
          { "code": "1F468 200D 1F466", "name": "family: man, boy" },
          { "code": "1F468 200D 1F466 200D 1F466", "name": "family: man, boy, boy" },
          { "code": "1F468 200D 1F467", "name": "family: man, girl" },
          { "code": "1F468 200D 1F467 200D 1F466", "name": "family: man, girl, boy" },
          { "code": "1F468 200D 1F467 200D 1F467", "name": "family: man, girl, girl" },
          { "code": "1F469 200D 1F466", "name": "family: woman, boy" },
          { "code": "1F469 200D 1F466 200D 1F466", "name": "family: woman, boy, boy" },
          { "code": "1F469 200D 1F467", "name": "family: woman, girl" },
          { "code": "1F469 200D 1F467 200D 1F466", "name": "family: woman, girl, boy" },
          { "code": "1F469 200D 1F467 200D 1F467", "name": "family: woman, girl, girl" }
        ]
      },
      {
        "name": "person-symbol",
        "emojis": [
          { "code": "1F5E3 FE0F", "name": "speaking head" },
          { "code": "1F464", "name": "bust in silhouette" },
          { "code": "1F465", "name": "busts in silhouette" },
          { "code": "1FAC2", "name": "people hugging" },
          { "code": "1F46A", "name": "family" },
          { "code": "1F9D1 200D 1F9D1 200D 1F9D2", "name": "family: adult, adult, child" },
          { "code": "1F9D1 200D 1F9D1 200D 1F9D2 200D 1F9D2", "name": "family: adult, adult, child, child" },
          { "code": "1F9D1 200D 1F9D2", "name": "family: adult, child" },
          { "code": "1F9D1 200D 1F9D2 200D 1F9D2", "name": "family: adult, child, child" },
          { "code": "1F463", "name": "footprints" },
          { "code": "1FAC6", "name": "fingerprint" }
        ]
      }
    ]
  },
  {
    "name": "Animals & Nature",
    "subGroups": [
      {
        "name": "animal-mammal",
        "emojis": [
          { "code": "1F435", "name": "monkey face" },
          { "code": "1F412", "name": "monkey" },
          { "code": "1F98D", "name": "gorilla" },
          { "code": "1F9A7", "name": "orangutan" },
          { "code": "1F436", "name": "dog face" },
          { "code": "1F415", "name": "dog" },
          { "code": "1F9AE", "name": "guide dog" },
          { "code": "1F415 200D 1F9BA", "name": "service dog" },
          { "code": "1F429", "name": "poodle" },
          { "code": "1F43A", "name": "wolf" },
          { "code": "1F98A", "name": "fox" },
          { "code": "1F99D", "name": "raccoon" },
          { "code": "1F431", "name": "cat face" },
          { "code": "1F408", "name": "cat" },
          { "code": "1F408 200D 2B1B", "name": "black cat" },
          { "code": "1F981", "name": "lion" },
          { "code": "1F42F", "name": "tiger face" },
          { "code": "1F405", "name": "tiger" },
          { "code": "1F406", "name": "leopard" },
          { "code": "1F434", "name": "horse face" },
          { "code": "1FACE", "name": "moose" },
          { "code": "1FACF", "name": "donkey" },
          { "code": "1F40E", "name": "horse" },
          { "code": "1F984", "name": "unicorn" },
          { "code": "1F993", "name": "zebra" },
          { "code": "1F98C", "name": "deer" },
          { "code": "1F9AC", "name": "bison" },
          { "code": "1F42E", "name": "cow face" },
          { "code": "1F402", "name": "ox" },
          { "code": "1F403", "name": "water buffalo" },
          { "code": "1F404", "name": "cow" },
          { "code": "1F437", "name": "pig face" },
          { "code": "1F416", "name": "pig" },
          { "code": "1F417", "name": "boar" },
          { "code": "1F43D", "name": "pig nose" },
          { "code": "1F40F", "name": "ram" },
          { "code": "1F411", "name": "ewe" },
          { "code": "1F410", "name": "goat" },
          { "code": "1F42A", "name": "camel" },
          { "code": "1F42B", "name": "two-hump camel" },
          { "code": "1F999", "name": "llama" },
          { "code": "1F992", "name": "giraffe" },
          { "code": "1F418", "name": "elephant" },
          { "code": "1F9A3", "name": "mammoth" },
          { "code": "1F98F", "name": "rhinoceros" },
          { "code": "1F99B", "name": "hippopotamus" },
          { "code": "1F42D", "name": "mouse face" },
          { "code": "1F401", "name": "mouse" },
          { "code": "1F400", "name": "rat" },
          { "code": "1F439", "name": "hamster" },
          { "code": "1F430", "name": "rabbit face" },
          { "code": "1F407", "name": "rabbit" },
          { "code": "1F43F FE0F", "name": "chipmunk" },
          { "code": "1F9AB", "name": "beaver" },
          { "code": "1F994", "name": "hedgehog" },
          { "code": "1F987", "name": "bat" },
          { "code": "1F43B", "name": "bear" },
          { "code": "1F43B 200D 2744 FE0F", "name": "polar bear" },
          { "code": "1F428", "name": "koala" },
          { "code": "1F43C", "name": "panda" },
          { "code": "1F9A5", "name": "sloth" },
          { "code": "1F9A6", "name": "otter" },
          { "code": "1F9A8", "name": "skunk" },
          { "code": "1F998", "name": "kangaroo" },
          { "code": "1F9A1", "name": "badger" },
          { "code": "1F43E", "name": "paw prints" }
        ]
      },
      {
        "name": "animal-bird",
        "emojis": [
          { "code": "1F983", "name": "turkey" },
          { "code": "1F414", "name": "chicken" },
          { "code": "1F413", "name": "rooster" },
          { "code": "1F423", "name": "hatching chick" },
          { "code": "1F424", "name": "baby chick" },
          { "code": "1F425", "name": "front-facing baby chick" },
          { "code": "1F426", "name": "bird" },
          { "code": "1F427", "name": "penguin" },
          { "code": "1F54A FE0F", "name": "dove" },
          { "code": "1F985", "name": "eagle" },
          { "code": "1F986", "name": "duck" },
          { "code": "1F9A2", "name": "swan" },
          { "code": "1F989", "name": "owl" },
          { "code": "1F9A4", "name": "dodo" },
          { "code": "1FAB6", "name": "feather" },
          { "code": "1F9A9", "name": "flamingo" },
          { "code": "1F99A", "name": "peacock" },
          { "code": "1F99C", "name": "parrot" },
          { "code": "1FABD", "name": "wing" },
          { "code": "1F426 200D 2B1B", "name": "black bird" },
          { "code": "1FABF", "name": "goose" },
          { "code": "1F426 200D 1F525", "name": "phoenix" }
        ]
      },
      {
        "name": "animal-amphibian",
        "emojis": [
          { "code": "1F438", "name": "frog" }
        ]
      },
      {
        "name": "animal-reptile",
        "emojis": [
          { "code": "1F40A", "name": "crocodile" },
          { "code": "1F422", "name": "turtle" },
          { "code": "1F98E", "name": "lizard" },
          { "code": "1F40D", "name": "snake" },
          { "code": "1F432", "name": "dragon face" },
          { "code": "1F409", "name": "dragon" },
          { "code": "1F995", "name": "sauropod" },
          { "code": "1F996", "name": "T-Rex" }
        ]
      },
      {
        "name": "animal-marine",
        "emojis": [
          { "code": "1F433", "name": "spouting whale" },
          { "code": "1F40B", "name": "whale" },
          { "code": "1F42C", "name": "dolphin" },
          { "code": "1FACD", "name": "orca" },
          { "code": "1F9AD", "name": "seal" },
          { "code": "1F41F", "name": "fish" },
          { "code": "1F420", "name": "tropical fish" },
          { "code": "1F421", "name": "blowfish" },
          { "code": "1F988", "name": "shark" },
          { "code": "1F419", "name": "octopus" },
          { "code": "1F41A", "name": "spiral shell" },
          { "code": "1FAB8", "name": "coral" },
          { "code": "1FABC", "name": "jellyfish" },
          { "code": "1F980", "name": "crab" },
          { "code": "1F99E", "name": "lobster" },
          { "code": "1F990", "name": "shrimp" },
          { "code": "1F991", "name": "squid" },
          { "code": "1F9AA", "name": "oyster" }
        ]
      },
      {
        "name": "animal-bug",
        "emojis": [
          { "code": "1F40C", "name": "snail" },
          { "code": "1F98B", "name": "butterfly" },
          { "code": "1F41B", "name": "bug" },
          { "code": "1F41C", "name": "ant" },
          { "code": "1F41D", "name": "honeybee" },
          { "code": "1FAB2", "name": "beetle" },
          { "code": "1F41E", "name": "lady beetle" },
          { "code": "1F997", "name": "cricket" },
          { "code": "1FAB3", "name": "cockroach" },
          { "code": "1F577 FE0F", "name": "spider" },
          { "code": "1F578 FE0F", "name": "spider web" },
          { "code": "1F982", "name": "scorpion" },
          { "code": "1F99F", "name": "mosquito" },
          { "code": "1FAB0", "name": "fly" },
          { "code": "1FAB1", "name": "worm" },
          { "code": "1F9A0", "name": "microbe" }
        ]
      },
      {
        "name": "plant-flower",
        "emojis": [
          { "code": "1F490", "name": "bouquet" },
          { "code": "1F338", "name": "cherry blossom" },
          { "code": "1F4AE", "name": "white flower" },
          { "code": "1FAB7", "name": "lotus" },
          { "code": "1F3F5 FE0F", "name": "rosette" },
          { "code": "1F339", "name": "rose" },
          { "code": "1F940", "name": "wilted flower" },
          { "code": "1F33A", "name": "hibiscus" },
          { "code": "1F33B", "name": "sunflower" },
          { "code": "1F33C", "name": "blossom" },
          { "code": "1F337", "name": "tulip" },
          { "code": "1FABB", "name": "hyacinth" }
        ]
      },
      {
        "name": "plant-other",
        "emojis": [
          { "code": "1F331", "name": "seedling" },
          { "code": "1FAB4", "name": "potted plant" },
          { "code": "1F332", "name": "evergreen tree" },
          { "code": "1F333", "name": "deciduous tree" },
          { "code": "1F334", "name": "palm tree" },
          { "code": "1F335", "name": "cactus" },
          { "code": "1F33E", "name": "sheaf of rice" },
          { "code": "1F33F", "name": "herb" },
          { "code": "2618 FE0F", "name": "shamrock" },
          { "code": "1F340", "name": "four leaf clover" },
          { "code": "1F341", "name": "maple leaf" },
          { "code": "1F342", "name": "fallen leaf" },
          { "code": "1F343", "name": "leaf fluttering in wind" },
          { "code": "1FAB9", "name": "empty nest" },
          { "code": "1FABA", "name": "nest with eggs" },
          { "code": "1F344", "name": "mushroom" },
          { "code": "1FABE", "name": "leafless tree" }
        ]
      }
    ]
  },
  {
    "name": "Food & Drink",
    "subGroups": [
      {
        "name": "food-fruit",
        "emojis": [
          { "code": "1F347", "name": "grapes" },
          { "code": "1F348", "name": "melon" },
          { "code": "1F349", "name": "watermelon" },
          { "code": "1F34A", "name": "tangerine" },
          { "code": "1F34B", "name": "lemon" },
          { "code": "1F34B 200D 1F7E9", "name": "lime" },
          { "code": "1F34C", "name": "banana" },
          { "code": "1F34D", "name": "pineapple" },
          { "code": "1F96D", "name": "mango" },
          { "code": "1F34E", "name": "red apple" },
          { "code": "1F34F", "name": "green apple" },
          { "code": "1F350", "name": "pear" },
          { "code": "1F351", "name": "peach" },
          { "code": "1F352", "name": "cherries" },
          { "code": "1F353", "name": "strawberry" },
          { "code": "1FAD0", "name": "blueberries" },
          { "code": "1F95D", "name": "kiwi fruit" },
          { "code": "1F345", "name": "tomato" },
          { "code": "1FAD2", "name": "olive" },
          { "code": "1F965", "name": "coconut" }
        ]
      },
      {
        "name": "food-vegetable",
        "emojis": [
          { "code": "1F951", "name": "avocado" },
          { "code": "1F346", "name": "eggplant" },
          { "code": "1F954", "name": "potato" },
          { "code": "1F955", "name": "carrot" },
          { "code": "1F33D", "name": "ear of corn" },
          { "code": "1F336 FE0F", "name": "hot pepper" },
          { "code": "1FAD1", "name": "bell pepper" },
          { "code": "1F952", "name": "cucumber" },
          { "code": "1F96C", "name": "leafy green" },
          { "code": "1F966", "name": "broccoli" },
          { "code": "1F9C4", "name": "garlic" },
          { "code": "1F9C5", "name": "onion" },
          { "code": "1F95C", "name": "peanuts" },
          { "code": "1FAD8", "name": "beans" },
          { "code": "1F330", "name": "chestnut" },
          { "code": "1FADA", "name": "ginger root" },
          { "code": "1FADB", "name": "pea pod" },
          { "code": "1F344 200D 1F7EB", "name": "brown mushroom" },
          { "code": "1FADC", "name": "root vegetable" }
        ]
      },
      {
        "name": "food-prepared",
        "emojis": [
          { "code": "1F35E", "name": "bread" },
          { "code": "1F950", "name": "croissant" },
          { "code": "1F956", "name": "baguette bread" },
          { "code": "1FAD3", "name": "flatbread" },
          { "code": "1F968", "name": "pretzel" },
          { "code": "1F96F", "name": "bagel" },
          { "code": "1F95E", "name": "pancakes" },
          { "code": "1F9C7", "name": "waffle" },
          { "code": "1F9C0", "name": "cheese wedge" },
          { "code": "1F356", "name": "meat on bone" },
          { "code": "1F357", "name": "poultry leg" },
          { "code": "1F969", "name": "cut of meat" },
          { "code": "1F953", "name": "bacon" },
          { "code": "1F354", "name": "hamburger" },
          { "code": "1F35F", "name": "french fries" },
          { "code": "1F355", "name": "pizza" },
          { "code": "1F32D", "name": "hot dog" },
          { "code": "1F96A", "name": "sandwich" },
          { "code": "1F32E", "name": "taco" },
          { "code": "1F32F", "name": "burrito" },
          { "code": "1FAD4", "name": "tamale" },
          { "code": "1F959", "name": "stuffed flatbread" },
          { "code": "1F9C6", "name": "falafel" },
          { "code": "1F95A", "name": "egg" },
          { "code": "1F373", "name": "cooking" },
          { "code": "1F958", "name": "shallow pan of food" },
          { "code": "1F372", "name": "pot of food" },
          { "code": "1FAD5", "name": "fondue" },
          { "code": "1F963", "name": "bowl with spoon" },
          { "code": "1F957", "name": "green salad" },
          { "code": "1F37F", "name": "popcorn" },
          { "code": "1F9C8", "name": "butter" },
          { "code": "1F9C2", "name": "salt" },
          { "code": "1F96B", "name": "canned food" }
        ]
      },
      {
        "name": "food-asian",
        "emojis": [
          { "code": "1F371", "name": "bento box" },
          { "code": "1F358", "name": "rice cracker" },
          { "code": "1F359", "name": "rice ball" },
          { "code": "1F35A", "name": "cooked rice" },
          { "code": "1F35B", "name": "curry rice" },
          { "code": "1F35C", "name": "steaming bowl" },
          { "code": "1F35D", "name": "spaghetti" },
          { "code": "1F360", "name": "roasted sweet potato" },
          { "code": "1F362", "name": "oden" },
          { "code": "1F363", "name": "sushi" },
          { "code": "1F364", "name": "fried shrimp" },
          { "code": "1F365", "name": "fish cake with swirl" },
          { "code": "1F96E", "name": "moon cake" },
          { "code": "1F361", "name": "dango" },
          { "code": "1F95F", "name": "dumpling" },
          { "code": "1F960", "name": "fortune cookie" },
          { "code": "1F961", "name": "takeout box" }
        ]
      },
      {
        "name": "food-sweet",
        "emojis": [
          { "code": "1F366", "name": "soft ice cream" },
          { "code": "1F367", "name": "shaved ice" },
          { "code": "1F368", "name": "ice cream" },
          { "code": "1F369", "name": "doughnut" },
          { "code": "1F36A", "name": "cookie" },
          { "code": "1F382", "name": "birthday cake" },
          { "code": "1F370", "name": "shortcake" },
          { "code": "1F9C1", "name": "cupcake" },
          { "code": "1F967", "name": "pie" },
          { "code": "1F36B", "name": "chocolate bar" },
          { "code": "1F36C", "name": "candy" },
          { "code": "1F36D", "name": "lollipop" },
          { "code": "1F36E", "name": "custard" },
          { "code": "1F36F", "name": "honey pot" }
        ]
      },
      {
        "name": "drink",
        "emojis": [
          { "code": "1F37C", "name": "baby bottle" },
          { "code": "1F95B", "name": "glass of milk" },
          { "code": "2615", "name": "hot beverage" },
          { "code": "1FAD6", "name": "teapot" },
          { "code": "1F375", "name": "teacup without handle" },
          { "code": "1F376", "name": "sake" },
          { "code": "1F37E", "name": "bottle with popping cork" },
          { "code": "1F377", "name": "wine glass" },
          { "code": "1F378", "name": "cocktail glass" },
          { "code": "1F379", "name": "tropical drink" },
          { "code": "1F37A", "name": "beer mug" },
          { "code": "1F37B", "name": "clinking beer mugs" },
          { "code": "1F942", "name": "clinking glasses" },
          { "code": "1F943", "name": "tumbler glass" },
          { "code": "1FAD7", "name": "pouring liquid" },
          { "code": "1F964", "name": "cup with straw" },
          { "code": "1F9CB", "name": "bubble tea" },
          { "code": "1F9C3", "name": "beverage box" },
          { "code": "1F9C9", "name": "mate" },
          { "code": "1F9CA", "name": "ice" }
        ]
      },
      {
        "name": "dishware",
        "emojis": [
          { "code": "1F962", "name": "chopsticks" },
          { "code": "1F37D FE0F", "name": "fork and knife with plate" },
          { "code": "1F374", "name": "fork and knife" },
          { "code": "1F944", "name": "spoon" },
          { "code": "1F52A", "name": "kitchen knife" },
          { "code": "1FAD9", "name": "jar" },
          { "code": "1F3FA", "name": "amphora" }
        ]
      }
    ]
  },
  {
    "name": "Travel & Places",
    "subGroups": [
      {
        "name": "place-map",
        "emojis": [
          { "code": "1F30D", "name": "globe showing Europe-Africa" },
          { "code": "1F30E", "name": "globe showing Americas" },
          { "code": "1F30F", "name": "globe showing Asia-Australia" },
          { "code": "1F310", "name": "globe with meridians" },
          { "code": "1F5FA FE0F", "name": "world map" },
          { "code": "1F5FE", "name": "map of Japan" },
          { "code": "1F9ED", "name": "compass" }
        ]
      },
      {
        "name": "place-geographic",
        "emojis": [
          { "code": "1F3D4 FE0F", "name": "snow-capped mountain" },
          { "code": "26F0 FE0F", "name": "mountain" },
          { "code": "1F6D8", "name": "landslide" },
          { "code": "1F30B", "name": "volcano" },
          { "code": "1F5FB", "name": "mount fuji" },
          { "code": "1F3D5 FE0F", "name": "camping" },
          { "code": "1F3D6 FE0F", "name": "beach with umbrella" },
          { "code": "1F3DC FE0F", "name": "desert" },
          { "code": "1F3DD FE0F", "name": "desert island" },
          { "code": "1F3DE FE0F", "name": "national park" }
        ]
      },
      {
        "name": "place-building",
        "emojis": [
          { "code": "1F3DF FE0F", "name": "stadium" },
          { "code": "1F3DB FE0F", "name": "classical building" },
          { "code": "1F3D7 FE0F", "name": "building construction" },
          { "code": "1F9F1", "name": "brick" },
          { "code": "1FAA8", "name": "rock" },
          { "code": "1FAB5", "name": "wood" },
          { "code": "1F6D6", "name": "hut" },
          { "code": "1F3D8 FE0F", "name": "houses" },
          { "code": "1F3DA FE0F", "name": "derelict house" },
          { "code": "1F3E0", "name": "house" },
          { "code": "1F3E1", "name": "house with garden" },
          { "code": "1F3E2", "name": "office building" },
          { "code": "1F3E3", "name": "Japanese post office" },
          { "code": "1F3E4", "name": "post office" },
          { "code": "1F3E5", "name": "hospital" },
          { "code": "1F3E6", "name": "bank" },
          { "code": "1F3E8", "name": "hotel" },
          { "code": "1F3E9", "name": "love hotel" },
          { "code": "1F3EA", "name": "convenience store" },
          { "code": "1F3EB", "name": "school" },
          { "code": "1F3EC", "name": "department store" },
          { "code": "1F3ED", "name": "factory" },
          { "code": "1F3EF", "name": "Japanese castle" },
          { "code": "1F3F0", "name": "castle" },
          { "code": "1F492", "name": "wedding" },
          { "code": "1F5FC", "name": "Tokyo tower" },
          { "code": "1F5FD", "name": "Statue of Liberty" }
        ]
      },
      {
        "name": "place-religious",
        "emojis": [
          { "code": "26EA", "name": "church" },
          { "code": "1F54C", "name": "mosque" },
          { "code": "1F6D5", "name": "hindu temple" },
          { "code": "1F54D", "name": "synagogue" },
          { "code": "26E9 FE0F", "name": "shinto shrine" },
          { "code": "1F54B", "name": "kaaba" }
        ]
      },
      {
        "name": "place-other",
        "emojis": [
          { "code": "26F2", "name": "fountain" },
          { "code": "26FA", "name": "tent" },
          { "code": "1F301", "name": "foggy" },
          { "code": "1F303", "name": "night with stars" },
          { "code": "1F3D9 FE0F", "name": "cityscape" },
          { "code": "1F304", "name": "sunrise over mountains" },
          { "code": "1F305", "name": "sunrise" },
          { "code": "1F306", "name": "cityscape at dusk" },
          { "code": "1F307", "name": "sunset" },
          { "code": "1F309", "name": "bridge at night" },
          { "code": "2668 FE0F", "name": "hot springs" },
          { "code": "1F3A0", "name": "carousel horse" },
          { "code": "1F6DD", "name": "playground slide" },
          { "code": "1F3A1", "name": "ferris wheel" },
          { "code": "1F3A2", "name": "roller coaster" },
          { "code": "1F488", "name": "barber pole" },
          { "code": "1F3AA", "name": "circus tent" }
        ]
      },
      {
        "name": "transport-ground",
        "emojis": [
          { "code": "1F682", "name": "locomotive" },
          { "code": "1F683", "name": "railway car" },
          { "code": "1F684", "name": "high-speed train" },
          { "code": "1F685", "name": "bullet train" },
          { "code": "1F686", "name": "train" },
          { "code": "1F687", "name": "metro" },
          { "code": "1F688", "name": "light rail" },
          { "code": "1F689", "name": "station" },
          { "code": "1F68A", "name": "tram" },
          { "code": "1F69D", "name": "monorail" },
          { "code": "1F69E", "name": "mountain railway" },
          { "code": "1F68B", "name": "tram car" },
          { "code": "1F68C", "name": "bus" },
          { "code": "1F68D", "name": "oncoming bus" },
          { "code": "1F68E", "name": "trolleybus" },
          { "code": "1F690", "name": "minibus" },
          { "code": "1F691", "name": "ambulance" },
          { "code": "1F692", "name": "fire engine" },
          { "code": "1F693", "name": "police car" },
          { "code": "1F694", "name": "oncoming police car" },
          { "code": "1F695", "name": "taxi" },
          { "code": "1F696", "name": "oncoming taxi" },
          { "code": "1F697", "name": "automobile" },
          { "code": "1F698", "name": "oncoming automobile" },
          { "code": "1F699", "name": "sport utility vehicle" },
          { "code": "1F6FB", "name": "pickup truck" },
          { "code": "1F69A", "name": "delivery truck" },
          { "code": "1F69B", "name": "articulated lorry" },
          { "code": "1F69C", "name": "tractor" },
          { "code": "1F3CE FE0F", "name": "racing car" },
          { "code": "1F3CD FE0F", "name": "motorcycle" },
          { "code": "1F6F5", "name": "motor scooter" },
          { "code": "1F9BD", "name": "manual wheelchair" },
          { "code": "1F9BC", "name": "motorized wheelchair" },
          { "code": "1F6FA", "name": "auto rickshaw" },
          { "code": "1F6B2", "name": "bicycle" },
          { "code": "1F6F4", "name": "kick scooter" },
          { "code": "1F6F9", "name": "skateboard" },
          { "code": "1F6FC", "name": "roller skate" },
          { "code": "1F68F", "name": "bus stop" },
          { "code": "1F6E3 FE0F", "name": "motorway" },
          { "code": "1F6E4 FE0F", "name": "railway track" },
          { "code": "1F6E2 FE0F", "name": "oil drum" },
          { "code": "26FD", "name": "fuel pump" },
          { "code": "1F6DE", "name": "wheel" },
          { "code": "1F6A8", "name": "police car light" },
          { "code": "1F6A5", "name": "horizontal traffic light" },
          { "code": "1F6A6", "name": "vertical traffic light" },
          { "code": "1F6D1", "name": "stop sign" },
          { "code": "1F6A7", "name": "construction" }
        ]
      },
      {
        "name": "transport-water",
        "emojis": [
          { "code": "2693", "name": "anchor" },
          { "code": "1F6DF", "name": "ring buoy" },
          { "code": "26F5", "name": "sailboat" },
          { "code": "1F6F6", "name": "canoe" },
          { "code": "1F6A4", "name": "speedboat" },
          { "code": "1F6F3 FE0F", "name": "passenger ship" },
          { "code": "26F4 FE0F", "name": "ferry" },
          { "code": "1F6E5 FE0F", "name": "motor boat" },
          { "code": "1F6A2", "name": "ship" }
        ]
      },
      {
        "name": "transport-air",
        "emojis": [
          { "code": "2708 FE0F", "name": "airplane" },
          { "code": "1F6E9 FE0F", "name": "small airplane" },
          { "code": "1F6EB", "name": "airplane departure" },
          { "code": "1F6EC", "name": "airplane arrival" },
          { "code": "1FA82", "name": "parachute" },
          { "code": "1F4BA", "name": "seat" },
          { "code": "1F681", "name": "helicopter" },
          { "code": "1F69F", "name": "suspension railway" },
          { "code": "1F6A0", "name": "mountain cableway" },
          { "code": "1F6A1", "name": "aerial tramway" },
          { "code": "1F6F0 FE0F", "name": "satellite" },
          { "code": "1F680", "name": "rocket" },
          { "code": "1F6F8", "name": "flying saucer" }
        ]
      },
      {
        "name": "hotel",
        "emojis": [
          { "code": "1F6CE FE0F", "name": "bellhop bell" },
          { "code": "1F9F3", "name": "luggage" }
        ]
      },
      {
        "name": "time",
        "emojis": [
          { "code": "231B", "name": "hourglass done" },
          { "code": "23F3", "name": "hourglass not done" },
          { "code": "231A", "name": "watch" },
          { "code": "23F0", "name": "alarm clock" },
          { "code": "23F1 FE0F", "name": "stopwatch" },
          { "code": "23F2 FE0F", "name": "timer clock" },
          { "code": "1F570 FE0F", "name": "mantelpiece clock" },
          { "code": "1F55B", "name": "twelve o’clock" },
          { "code": "1F567", "name": "twelve-thirty" },
          { "code": "1F550", "name": "one o’clock" },
          { "code": "1F55C", "name": "one-thirty" },
          { "code": "1F551", "name": "two o’clock" },
          { "code": "1F55D", "name": "two-thirty" },
          { "code": "1F552", "name": "three o’clock" },
          { "code": "1F55E", "name": "three-thirty" },
          { "code": "1F553", "name": "four o’clock" },
          { "code": "1F55F", "name": "four-thirty" },
          { "code": "1F554", "name": "five o’clock" },
          { "code": "1F560", "name": "five-thirty" },
          { "code": "1F555", "name": "six o’clock" },
          { "code": "1F561", "name": "six-thirty" },
          { "code": "1F556", "name": "seven o’clock" },
          { "code": "1F562", "name": "seven-thirty" },
          { "code": "1F557", "name": "eight o’clock" },
          { "code": "1F563", "name": "eight-thirty" },
          { "code": "1F558", "name": "nine o’clock" },
          { "code": "1F564", "name": "nine-thirty" },
          { "code": "1F559", "name": "ten o’clock" },
          { "code": "1F565", "name": "ten-thirty" },
          { "code": "1F55A", "name": "eleven o’clock" },
          { "code": "1F566", "name": "eleven-thirty" }
        ]
      },
      {
        "name": "sky & weather",
        "emojis": [
          { "code": "1F311", "name": "new moon" },
          { "code": "1F312", "name": "waxing crescent moon" },
          { "code": "1F313", "name": "first quarter moon" },
          { "code": "1F314", "name": "waxing gibbous moon" },
          { "code": "1F315", "name": "full moon" },
          { "code": "1F316", "name": "waning gibbous moon" },
          { "code": "1F317", "name": "last quarter moon" },
          { "code": "1F318", "name": "waning crescent moon" },
          { "code": "1F319", "name": "crescent moon" },
          { "code": "1F31A", "name": "new moon face" },
          { "code": "1F31B", "name": "first quarter moon face" },
          { "code": "1F31C", "name": "last quarter moon face" },
          { "code": "1F321 FE0F", "name": "thermometer" },
          { "code": "2600 FE0F", "name": "sun" },
          { "code": "1F31D", "name": "full moon face" },
          { "code": "1F31E", "name": "sun with face" },
          { "code": "1FA90", "name": "ringed planet" },
          { "code": "2B50", "name": "star" },
          { "code": "1F31F", "name": "glowing star" },
          { "code": "1F320", "name": "shooting star" },
          { "code": "1F30C", "name": "milky way" },
          { "code": "2601 FE0F", "name": "cloud" },
          { "code": "26C5", "name": "sun behind cloud" },
          { "code": "26C8 FE0F", "name": "cloud with lightning and rain" },
          { "code": "1F324 FE0F", "name": "sun behind small cloud" },
          { "code": "1F325 FE0F", "name": "sun behind large cloud" },
          { "code": "1F326 FE0F", "name": "sun behind rain cloud" },
          { "code": "1F327 FE0F", "name": "cloud with rain" },
          { "code": "1F328 FE0F", "name": "cloud with snow" },
          { "code": "1F329 FE0F", "name": "cloud with lightning" },
          { "code": "1F32A FE0F", "name": "tornado" },
          { "code": "1F32B FE0F", "name": "fog" },
          { "code": "1F32C FE0F", "name": "wind face" },
          { "code": "1F300", "name": "cyclone" },
          { "code": "1F308", "name": "rainbow" },
          { "code": "1F302", "name": "closed umbrella" },
          { "code": "2602 FE0F", "name": "umbrella" },
          { "code": "2614", "name": "umbrella with rain drops" },
          { "code": "26F1 FE0F", "name": "umbrella on ground" },
          { "code": "26A1", "name": "high voltage" },
          { "code": "2744 FE0F", "name": "snowflake" },
          { "code": "2603 FE0F", "name": "snowman" },
          { "code": "26C4", "name": "snowman without snow" },
          { "code": "2604 FE0F", "name": "comet" },
          { "code": "1F525", "name": "fire" },
          { "code": "1F4A7", "name": "droplet" },
          { "code": "1F30A", "name": "water wave" }
        ]
      }
    ]
  },
  {
    "name": "Activities",
    "subGroups": [
      {
        "name": "event",
        "emojis": [
          { "code": "1F383", "name": "jack-o-lantern" },
          { "code": "1F384", "name": "Christmas tree" },
          { "code": "1F386", "name": "fireworks" },
          { "code": "1F387", "name": "sparkler" },
          { "code": "1F9E8", "name": "firecracker" },
          { "code": "2728", "name": "sparkles" },
          { "code": "1F388", "name": "balloon" },
          { "code": "1F389", "name": "party popper" },
          { "code": "1F38A", "name": "confetti ball" },
          { "code": "1F38B", "name": "tanabata tree" },
          { "code": "1F38D", "name": "pine decoration" },
          { "code": "1F38E", "name": "Japanese dolls" },
          { "code": "1F38F", "name": "carp streamer" },
          { "code": "1F390", "name": "wind chime" },
          { "code": "1F391", "name": "moon viewing ceremony" },
          { "code": "1F9E7", "name": "red envelope" },
          { "code": "1F380", "name": "ribbon" },
          { "code": "1F381", "name": "wrapped gift" },
          { "code": "1F397 FE0F", "name": "reminder ribbon" },
          { "code": "1F39F FE0F", "name": "admission tickets" },
          { "code": "1F3AB", "name": "ticket" }
        ]
      },
      {
        "name": "award-medal",
        "emojis": [
          { "code": "1F396 FE0F", "name": "military medal" },
          { "code": "1F3C6", "name": "trophy" },
          { "code": "1F3C5", "name": "sports medal" },
          { "code": "1F947", "name": "1st place medal" },
          { "code": "1F948", "name": "2nd place medal" },
          { "code": "1F949", "name": "3rd place medal" }
        ]
      },
      {
        "name": "sport",
        "emojis": [
          { "code": "26BD", "name": "soccer ball" },
          { "code": "26BE", "name": "baseball" },
          { "code": "1F94E", "name": "softball" },
          { "code": "1F3C0", "name": "basketball" },
          { "code": "1F3D0", "name": "volleyball" },
          { "code": "1F3C8", "name": "american football" },
          { "code": "1F3C9", "name": "rugby football" },
          { "code": "1F3BE", "name": "tennis" },
          { "code": "1F94F", "name": "flying disc" },
          { "code": "1F3B3", "name": "bowling" },
          { "code": "1F3CF", "name": "cricket game" },
          { "code": "1F3D1", "name": "field hockey" },
          { "code": "1F3D2", "name": "ice hockey" },
          { "code": "1F94D", "name": "lacrosse" },
          { "code": "1F3D3", "name": "ping pong" },
          { "code": "1F3F8", "name": "badminton" },
          { "code": "1F94A", "name": "boxing glove" },
          { "code": "1F94B", "name": "martial arts uniform" },
          { "code": "1F945", "name": "goal net" },
          { "code": "26F3", "name": "flag in hole" },
          { "code": "26F8 FE0F", "name": "ice skate" },
          { "code": "1F3A3", "name": "fishing pole" },
          { "code": "1F93F", "name": "diving mask" },
          { "code": "1F3BD", "name": "running shirt" },
          { "code": "1F3BF", "name": "skis" },
          { "code": "1F6F7", "name": "sled" },
          { "code": "1F94C", "name": "curling stone" }
        ]
      },
      {
        "name": "game",
        "emojis": [
          { "code": "1F3AF", "name": "bullseye" },
          { "code": "1FA80", "name": "yo-yo" },
          { "code": "1FA81", "name": "kite" },
          { "code": "1F52B", "name": "water pistol" },
          { "code": "1F3B1", "name": "pool 8 ball" },
          { "code": "1F52E", "name": "crystal ball" },
          { "code": "1FA84", "name": "magic wand" },
          { "code": "1F3AE", "name": "video game" },
          { "code": "1F579 FE0F", "name": "joystick" },
          { "code": "1F3B0", "name": "slot machine" },
          { "code": "1F3B2", "name": "game die" },
          { "code": "1F9E9", "name": "puzzle piece" },
          { "code": "1F9F8", "name": "teddy bear" },
          { "code": "1FA85", "name": "piñata" },
          { "code": "1FAA9", "name": "mirror ball" },
          { "code": "1FA86", "name": "nesting dolls" },
          { "code": "2660 FE0F", "name": "spade suit" },
          { "code": "2665 FE0F", "name": "heart suit" },
          { "code": "2666 FE0F", "name": "diamond suit" },
          { "code": "2663 FE0F", "name": "club suit" },
          { "code": "265F FE0F", "name": "chess pawn" },
          { "code": "1F0CF", "name": "joker" },
          { "code": "1F004", "name": "mahjong red dragon" },
          { "code": "1F3B4", "name": "flower playing cards" }
        ]
      },
      {
        "name": "arts & crafts",
        "emojis": [
          { "code": "1F3AD", "name": "performing arts" },
          { "code": "1F5BC FE0F", "name": "framed picture" },
          { "code": "1F3A8", "name": "artist palette" },
          { "code": "1F9F5", "name": "thread" },
          { "code": "1FAA1", "name": "sewing needle" },
          { "code": "1F9F6", "name": "yarn" },
          { "code": "1FAA2", "name": "knot" }
        ]
      }
    ]
  },
  {
    "name": "Objects",
    "subGroups": [
      {
        "name": "clothing",
        "emojis": [
          { "code": "1F453", "name": "glasses" },
          { "code": "1F576 FE0F", "name": "sunglasses" },
          { "code": "1F97D", "name": "goggles" },
          { "code": "1F97C", "name": "lab coat" },
          { "code": "1F9BA", "name": "safety vest" },
          { "code": "1F454", "name": "necktie" },
          { "code": "1F455", "name": "t-shirt" },
          { "code": "1F456", "name": "jeans" },
          { "code": "1F9E3", "name": "scarf" },
          { "code": "1F9E4", "name": "gloves" },
          { "code": "1F9E5", "name": "coat" },
          { "code": "1F9E6", "name": "socks" },
          { "code": "1F457", "name": "dress" },
          { "code": "1F458", "name": "kimono" },
          { "code": "1F97B", "name": "sari" },
          { "code": "1FA71", "name": "one-piece swimsuit" },
          { "code": "1FA72", "name": "briefs" },
          { "code": "1FA73", "name": "shorts" },
          { "code": "1F459", "name": "bikini" },
          { "code": "1F45A", "name": "woman’s clothes" },
          { "code": "1FAAD", "name": "folding hand fan" },
          { "code": "1F45B", "name": "purse" },
          { "code": "1F45C", "name": "handbag" },
          { "code": "1F45D", "name": "clutch bag" },
          { "code": "1F6CD FE0F", "name": "shopping bags" },
          { "code": "1F392", "name": "backpack" },
          { "code": "1FA74", "name": "thong sandal" },
          { "code": "1F45E", "name": "man’s shoe" },
          { "code": "1F45F", "name": "running shoe" },
          { "code": "1F97E", "name": "hiking boot" },
          { "code": "1F97F", "name": "flat shoe" },
          { "code": "1F460", "name": "high-heeled shoe" },
          { "code": "1F461", "name": "woman’s sandal" },
          { "code": "1FA70", "name": "ballet shoes" },
          { "code": "1F462", "name": "woman’s boot" },
          { "code": "1FAAE", "name": "hair pick" },
          { "code": "1F451", "name": "crown" },
          { "code": "1F452", "name": "woman’s hat" },
          { "code": "1F3A9", "name": "top hat" },
          { "code": "1F393", "name": "graduation cap" },
          { "code": "1F9E2", "name": "billed cap" },
          { "code": "1FA96", "name": "military helmet" },
          { "code": "26D1 FE0F", "name": "rescue worker’s helmet" },
          { "code": "1F4FF", "name": "prayer beads" },
          { "code": "1F484", "name": "lipstick" },
          { "code": "1F48D", "name": "ring" },
          { "code": "1F48E", "name": "gem stone" }
        ]
      },
      {
        "name": "sound",
        "emojis": [
          { "code": "1F507", "name": "muted speaker" },
          { "code": "1F508", "name": "speaker low volume" },
          { "code": "1F509", "name": "speaker medium volume" },
          { "code": "1F50A", "name": "speaker high volume" },
          { "code": "1F4E2", "name": "loudspeaker" },
          { "code": "1F4E3", "name": "megaphone" },
          { "code": "1F4EF", "name": "postal horn" },
          { "code": "1F514", "name": "bell" },
          { "code": "1F515", "name": "bell with slash" }
        ]
      },
      {
        "name": "music",
        "emojis": [
          { "code": "1F3BC", "name": "musical score" },
          { "code": "1F3B5", "name": "musical note" },
          { "code": "1F3B6", "name": "musical notes" },
          { "code": "1F399 FE0F", "name": "studio microphone" },
          { "code": "1F39A FE0F", "name": "level slider" },
          { "code": "1F39B FE0F", "name": "control knobs" },
          { "code": "1F3A4", "name": "microphone" },
          { "code": "1F3A7", "name": "headphone" },
          { "code": "1F4FB", "name": "radio" }
        ]
      },
      {
        "name": "musical-instrument",
        "emojis": [
          { "code": "1F3B7", "name": "saxophone" },
          { "code": "1F3BA", "name": "trumpet" },
          { "code": "1FA8A", "name": "trombone" },
          { "code": "1FA97", "name": "accordion" },
          { "code": "1F3B8", "name": "guitar" },
          { "code": "1F3B9", "name": "musical keyboard" },
          { "code": "1F3BB", "name": "violin" },
          { "code": "1FA95", "name": "banjo" },
          { "code": "1F941", "name": "drum" },
          { "code": "1FA98", "name": "long drum" },
          { "code": "1FA87", "name": "maracas" },
          { "code": "1FA88", "name": "flute" },
          { "code": "1FA89", "name": "harp" }
        ]
      },
      {
        "name": "phone",
        "emojis": [
          { "code": "1F4F1", "name": "mobile phone" },
          { "code": "1F4F2", "name": "mobile phone with arrow" },
          { "code": "260E FE0F", "name": "telephone" },
          { "code": "1F4DE", "name": "telephone receiver" },
          { "code": "1F4DF", "name": "pager" },
          { "code": "1F4E0", "name": "fax machine" }
        ]
      },
      {
        "name": "computer",
        "emojis": [
          { "code": "1F50B", "name": "battery" },
          { "code": "1FAAB", "name": "low battery" },
          { "code": "1F50C", "name": "electric plug" },
          { "code": "1F4BB", "name": "laptop" },
          { "code": "1F5A5 FE0F", "name": "desktop computer" },
          { "code": "1F5A8 FE0F", "name": "printer" },
          { "code": "2328 FE0F", "name": "keyboard" },
          { "code": "1F5B1 FE0F", "name": "computer mouse" },
          { "code": "1F5B2 FE0F", "name": "trackball" },
          { "code": "1F4BD", "name": "computer disk" },
          { "code": "1F4BE", "name": "floppy disk" },
          { "code": "1F4BF", "name": "optical disk" },
          { "code": "1F4C0", "name": "dvd" },
          { "code": "1F9EE", "name": "abacus" }
        ]
      },
      {
        "name": "light & video",
        "emojis": [
          { "code": "1F3A5", "name": "movie camera" },
          { "code": "1F39E FE0F", "name": "film frames" },
          { "code": "1F4FD FE0F", "name": "film projector" },
          { "code": "1F3AC", "name": "clapper board" },
          { "code": "1F4FA", "name": "television" },
          { "code": "1F4F7", "name": "camera" },
          { "code": "1F4F8", "name": "camera with flash" },
          { "code": "1F4F9", "name": "video camera" },
          { "code": "1F4FC", "name": "videocassette" },
          { "code": "1F50D", "name": "magnifying glass tilted left" },
          { "code": "1F50E", "name": "magnifying glass tilted right" },
          { "code": "1F56F FE0F", "name": "candle" },
          { "code": "1F4A1", "name": "light bulb" },
          { "code": "1F526", "name": "flashlight" },
          { "code": "1F3EE", "name": "red paper lantern" },
          { "code": "1FA94", "name": "diya lamp" }
        ]
      },
      {
        "name": "book-paper",
        "emojis": [
          { "code": "1F4D4", "name": "notebook with decorative cover" },
          { "code": "1F4D5", "name": "closed book" },
          { "code": "1F4D6", "name": "open book" },
          { "code": "1F4D7", "name": "green book" },
          { "code": "1F4D8", "name": "blue book" },
          { "code": "1F4D9", "name": "orange book" },
          { "code": "1F4DA", "name": "books" },
          { "code": "1F4D3", "name": "notebook" },
          { "code": "1F4D2", "name": "ledger" },
          { "code": "1F4C3", "name": "page with curl" },
          { "code": "1F4DC", "name": "scroll" },
          { "code": "1F4C4", "name": "page facing up" },
          { "code": "1F4F0", "name": "newspaper" },
          { "code": "1F5DE FE0F", "name": "rolled-up newspaper" },
          { "code": "1F4D1", "name": "bookmark tabs" },
          { "code": "1F516", "name": "bookmark" },
          { "code": "1F3F7 FE0F", "name": "label" }
        ]
      },
      {
        "name": "money",
        "emojis": [
          { "code": "1FA99", "name": "coin" },
          { "code": "1F4B0", "name": "money bag" },
          { "code": "1FA8E", "name": "treasure chest" },
          { "code": "1F4B4", "name": "yen banknote" },
          { "code": "1F4B5", "name": "dollar banknote" },
          { "code": "1F4B6", "name": "euro banknote" },
          { "code": "1F4B7", "name": "pound banknote" },
          { "code": "1F4B8", "name": "money with wings" },
          { "code": "1F4B3", "name": "credit card" },
          { "code": "1F9FE", "name": "receipt" },
          { "code": "1F4B9", "name": "chart increasing with yen" }
        ]
      },
      {
        "name": "mail",
        "emojis": [
          { "code": "2709 FE0F", "name": "envelope" },
          { "code": "1F4E7", "name": "e-mail" },
          { "code": "1F4E8", "name": "incoming envelope" },
          { "code": "1F4E9", "name": "envelope with arrow" },
          { "code": "1F4E4", "name": "outbox tray" },
          { "code": "1F4E5", "name": "inbox tray" },
          { "code": "1F4E6", "name": "package" },
          { "code": "1F4EB", "name": "closed mailbox with raised flag" },
          { "code": "1F4EA", "name": "closed mailbox with lowered flag" },
          { "code": "1F4EC", "name": "open mailbox with raised flag" },
          { "code": "1F4ED", "name": "open mailbox with lowered flag" },
          { "code": "1F4EE", "name": "postbox" },
          { "code": "1F5F3 FE0F", "name": "ballot box with ballot" }
        ]
      },
      {
        "name": "writing",
        "emojis": [
          { "code": "270F FE0F", "name": "pencil" },
          { "code": "2712 FE0F", "name": "black nib" },
          { "code": "1F58B FE0F", "name": "fountain pen" },
          { "code": "1F58A FE0F", "name": "pen" },
          { "code": "1F58C FE0F", "name": "paintbrush" },
          { "code": "1F58D FE0F", "name": "crayon" },
          { "code": "1F4DD", "name": "memo" }
        ]
      },
      {
        "name": "office",
        "emojis": [
          { "code": "1F4BC", "name": "briefcase" },
          { "code": "1F4C1", "name": "file folder" },
          { "code": "1F4C2", "name": "open file folder" },
          { "code": "1F5C2 FE0F", "name": "card index dividers" },
          { "code": "1F4C5", "name": "calendar" },
          { "code": "1F4C6", "name": "tear-off calendar" },
          { "code": "1F5D2 FE0F", "name": "spiral notepad" },
          { "code": "1F5D3 FE0F", "name": "spiral calendar" },
          { "code": "1F4C7", "name": "card index" },
          { "code": "1F4C8", "name": "chart increasing" },
          { "code": "1F4C9", "name": "chart decreasing" },
          { "code": "1F4CA", "name": "bar chart" },
          { "code": "1F4CB", "name": "clipboard" },
          { "code": "1F4CC", "name": "pushpin" },
          { "code": "1F4CD", "name": "round pushpin" },
          { "code": "1F4CE", "name": "paperclip" },
          { "code": "1F587 FE0F", "name": "linked paperclips" },
          { "code": "1F4CF", "name": "straight ruler" },
          { "code": "1F4D0", "name": "triangular ruler" },
          { "code": "2702 FE0F", "name": "scissors" },
          { "code": "1F5C3 FE0F", "name": "card file box" },
          { "code": "1F5C4 FE0F", "name": "file cabinet" },
          { "code": "1F5D1 FE0F", "name": "wastebasket" }
        ]
      },
      {
        "name": "lock",
        "emojis": [
          { "code": "1F512", "name": "locked" },
          { "code": "1F513", "name": "unlocked" },
          { "code": "1F50F", "name": "locked with pen" },
          { "code": "1F510", "name": "locked with key" },
          { "code": "1F511", "name": "key" },
          { "code": "1F5DD FE0F", "name": "old key" }
        ]
      },
      {
        "name": "tool",
        "emojis": [
          { "code": "1F528", "name": "hammer" },
          { "code": "1FA93", "name": "axe" },
          { "code": "26CF FE0F", "name": "pick" },
          { "code": "2692 FE0F", "name": "hammer and pick" },
          { "code": "1F6E0 FE0F", "name": "hammer and wrench" },
          { "code": "1F5E1 FE0F", "name": "dagger" },
          { "code": "2694 FE0F", "name": "crossed swords" },
          { "code": "1F4A3", "name": "bomb" },
          { "code": "1FA83", "name": "boomerang" },
          { "code": "1F3F9", "name": "bow and arrow" },
          { "code": "1F6E1 FE0F", "name": "shield" },
          { "code": "1FA9A", "name": "carpentry saw" },
          { "code": "1F527", "name": "wrench" },
          { "code": "1FA9B", "name": "screwdriver" },
          { "code": "1F529", "name": "nut and bolt" },
          { "code": "2699 FE0F", "name": "gear" },
          { "code": "1F5DC FE0F", "name": "clamp" },
          { "code": "2696 FE0F", "name": "balance scale" },
          { "code": "1F9AF", "name": "white cane" },
          { "code": "1F517", "name": "link" },
          { "code": "26D3 FE0F 200D 1F4A5", "name": "broken chain" },
          { "code": "26D3 FE0F", "name": "chains" },
          { "code": "1FA9D", "name": "hook" },
          { "code": "1F9F0", "name": "toolbox" },
          { "code": "1F9F2", "name": "magnet" },
          { "code": "1FA9C", "name": "ladder" },
          { "code": "1FA8F", "name": "shovel" }
        ]
      },
      {
        "name": "science",
        "emojis": [
          { "code": "2697 FE0F", "name": "alembic" },
          { "code": "1F9EA", "name": "test tube" },
          { "code": "1F9EB", "name": "petri dish" },
          { "code": "1F9EC", "name": "dna" },
          { "code": "1F52C", "name": "microscope" },
          { "code": "1F52D", "name": "telescope" },
          { "code": "1F4E1", "name": "satellite antenna" }
        ]
      },
      {
        "name": "medical",
        "emojis": [
          { "code": "1F489", "name": "syringe" },
          { "code": "1FA78", "name": "drop of blood" },
          { "code": "1F48A", "name": "pill" },
          { "code": "1FA79", "name": "adhesive bandage" },
          { "code": "1FA7C", "name": "crutch" },
          { "code": "1FA7A", "name": "stethoscope" },
          { "code": "1FA7B", "name": "x-ray" }
        ]
      },
      {
        "name": "household",
        "emojis": [
          { "code": "1F6AA", "name": "door" },
          { "code": "1F6D7", "name": "elevator" },
          { "code": "1FA9E", "name": "mirror" },
          { "code": "1FA9F", "name": "window" },
          { "code": "1F6CF FE0F", "name": "bed" },
          { "code": "1F6CB FE0F", "name": "couch and lamp" },
          { "code": "1FA91", "name": "chair" },
          { "code": "1F6BD", "name": "toilet" },
          { "code": "1FAA0", "name": "plunger" },
          { "code": "1F6BF", "name": "shower" },
          { "code": "1F6C1", "name": "bathtub" },
          { "code": "1FAA4", "name": "mouse trap" },
          { "code": "1FA92", "name": "razor" },
          { "code": "1F9F4", "name": "lotion bottle" },
          { "code": "1F9F7", "name": "safety pin" },
          { "code": "1F9F9", "name": "broom" },
          { "code": "1F9FA", "name": "basket" },
          { "code": "1F9FB", "name": "roll of paper" },
          { "code": "1FAA3", "name": "bucket" },
          { "code": "1F9FC", "name": "soap" },
          { "code": "1FAE7", "name": "bubbles" },
          { "code": "1FAA5", "name": "toothbrush" },
          { "code": "1F9FD", "name": "sponge" },
          { "code": "1F9EF", "name": "fire extinguisher" },
          { "code": "1F6D2", "name": "shopping cart" }
        ]
      },
      {
        "name": "other-object",
        "emojis": [
          { "code": "1F6AC", "name": "cigarette" },
          { "code": "26B0 FE0F", "name": "coffin" },
          { "code": "1FAA6", "name": "headstone" },
          { "code": "26B1 FE0F", "name": "funeral urn" },
          { "code": "1F9FF", "name": "nazar amulet" },
          { "code": "1FAAC", "name": "hamsa" },
          { "code": "1F5FF", "name": "moai" },
          { "code": "1FAA7", "name": "placard" },
          { "code": "1FAAA", "name": "identification card" }
        ]
      }
    ]
  },
  {
    "name": "Symbols",
    "subGroups": [
      {
        "name": "transport-sign",
        "emojis": [
          { "code": "1F3E7", "name": "ATM sign" },
          { "code": "1F6AE", "name": "litter in bin sign" },
          { "code": "1F6B0", "name": "potable water" },
          { "code": "267F", "name": "wheelchair symbol" },
          { "code": "1F6B9", "name": "men’s room" },
          { "code": "1F6BA", "name": "women’s room" },
          { "code": "1F6BB", "name": "restroom" },
          { "code": "1F6BC", "name": "baby symbol" },
          { "code": "1F6BE", "name": "water closet" },
          { "code": "1F6C2", "name": "passport control" },
          { "code": "1F6C3", "name": "customs" },
          { "code": "1F6C4", "name": "baggage claim" },
          { "code": "1F6C5", "name": "left luggage" }
        ]
      },
      {
        "name": "warning",
        "emojis": [
          { "code": "26A0 FE0F", "name": "warning" },
          { "code": "1F6B8", "name": "children crossing" },
          { "code": "26D4", "name": "no entry" },
          { "code": "1F6AB", "name": "prohibited" },
          { "code": "1F6B3", "name": "no bicycles" },
          { "code": "1F6AD", "name": "no smoking" },
          { "code": "1F6AF", "name": "no littering" },
          { "code": "1F6B1", "name": "non-potable water" },
          { "code": "1F6B7", "name": "no pedestrians" },
          { "code": "1F4F5", "name": "no mobile phones" },
          { "code": "1F51E", "name": "no one under eighteen" },
          { "code": "2622 FE0F", "name": "radioactive" },
          { "code": "2623 FE0F", "name": "biohazard" }
        ]
      },
      {
        "name": "arrow",
        "emojis": [
          { "code": "2B06 FE0F", "name": "up arrow" },
          { "code": "2197 FE0F", "name": "up-right arrow" },
          { "code": "27A1 FE0F", "name": "right arrow" },
          { "code": "2198 FE0F", "name": "down-right arrow" },
          { "code": "2B07 FE0F", "name": "down arrow" },
          { "code": "2199 FE0F", "name": "down-left arrow" },
          { "code": "2B05 FE0F", "name": "left arrow" },
          { "code": "2196 FE0F", "name": "up-left arrow" },
          { "code": "2195 FE0F", "name": "up-down arrow" },
          { "code": "2194 FE0F", "name": "left-right arrow" },
          { "code": "21A9 FE0F", "name": "right arrow curving left" },
          { "code": "21AA FE0F", "name": "left arrow curving right" },
          { "code": "2934 FE0F", "name": "right arrow curving up" },
          { "code": "2935 FE0F", "name": "right arrow curving down" },
          { "code": "1F503", "name": "clockwise vertical arrows" },
          { "code": "1F504", "name": "counterclockwise arrows button" },
          { "code": "1F519", "name": "BACK arrow" },
          { "code": "1F51A", "name": "END arrow" },
          { "code": "1F51B", "name": "ON! arrow" },
          { "code": "1F51C", "name": "SOON arrow" },
          { "code": "1F51D", "name": "TOP arrow" }
        ]
      },
      {
        "name": "religion",
        "emojis": [
          { "code": "1F6D0", "name": "place of worship" },
          { "code": "269B FE0F", "name": "atom symbol" },
          { "code": "1F549 FE0F", "name": "om" },
          { "code": "2721 FE0F", "name": "star of David" },
          { "code": "2638 FE0F", "name": "wheel of dharma" },
          { "code": "262F FE0F", "name": "yin yang" },
          { "code": "271D FE0F", "name": "latin cross" },
          { "code": "2626 FE0F", "name": "orthodox cross" },
          { "code": "262A FE0F", "name": "star and crescent" },
          { "code": "262E FE0F", "name": "peace symbol" },
          { "code": "1F54E", "name": "menorah" },
          { "code": "1F52F", "name": "dotted six-pointed star" },
          { "code": "1FAAF", "name": "khanda" }
        ]
      },
      {
        "name": "zodiac",
        "emojis": [
          { "code": "2648", "name": "Aries" },
          { "code": "2649", "name": "Taurus" },
          { "code": "264A", "name": "Gemini" },
          { "code": "264B", "name": "Cancer" },
          { "code": "264C", "name": "Leo" },
          { "code": "264D", "name": "Virgo" },
          { "code": "264E", "name": "Libra" },
          { "code": "264F", "name": "Scorpio" },
          { "code": "2650", "name": "Sagittarius" },
          { "code": "2651", "name": "Capricorn" },
          { "code": "2652", "name": "Aquarius" },
          { "code": "2653", "name": "Pisces" },
          { "code": "26CE", "name": "Ophiuchus" }
        ]
      },
      {
        "name": "av-symbol",
        "emojis": [
          { "code": "1F500", "name": "shuffle tracks button" },
          { "code": "1F501", "name": "repeat button" },
          { "code": "1F502", "name": "repeat single button" },
          { "code": "25B6 FE0F", "name": "play button" },
          { "code": "23E9", "name": "fast-forward button" },
          { "code": "23ED FE0F", "name": "next track button" },
          { "code": "23EF FE0F", "name": "play or pause button" },
          { "code": "25C0 FE0F", "name": "reverse button" },
          { "code": "23EA", "name": "fast reverse button" },
          { "code": "23EE FE0F", "name": "last track button" },
          { "code": "1F53C", "name": "upwards button" },
          { "code": "23EB", "name": "fast up button" },
          { "code": "1F53D", "name": "downwards button" },
          { "code": "23EC", "name": "fast down button" },
          { "code": "23F8 FE0F", "name": "pause button" },
          { "code": "23F9 FE0F", "name": "stop button" },
          { "code": "23FA FE0F", "name": "record button" },
          { "code": "23CF FE0F", "name": "eject button" },
          { "code": "1F3A6", "name": "cinema" },
          { "code": "1F505", "name": "dim button" },
          { "code": "1F506", "name": "bright button" },
          { "code": "1F4F6", "name": "antenna bars" },
          { "code": "1F6DC", "name": "wireless" },
          { "code": "1F4F3", "name": "vibration mode" },
          { "code": "1F4F4", "name": "mobile phone off" }
        ]
      },
      {
        "name": "gender",
        "emojis": [
          { "code": "2640 FE0F", "name": "female sign" },
          { "code": "2642 FE0F", "name": "male sign" },
          { "code": "26A7 FE0F", "name": "transgender symbol" }
        ]
      },
      {
        "name": "math",
        "emojis": [
          { "code": "2716 FE0F", "name": "multiply" },
          { "code": "2795", "name": "plus" },
          { "code": "2796", "name": "minus" },
          { "code": "2797", "name": "divide" },
          { "code": "1F7F0", "name": "heavy equals sign" },
          { "code": "267E FE0F", "name": "infinity" }
        ]
      },
      {
        "name": "punctuation",
        "emojis": [
          { "code": "203C FE0F", "name": "double exclamation mark" },
          { "code": "2049 FE0F", "name": "exclamation question mark" },
          { "code": "2753", "name": "red question mark" },
          { "code": "2754", "name": "white question mark" },
          { "code": "2755", "name": "white exclamation mark" },
          { "code": "2757", "name": "red exclamation mark" },
          { "code": "3030 FE0F", "name": "wavy dash" }
        ]
      },
      {
        "name": "currency",
        "emojis": [
          { "code": "1F4B1", "name": "currency exchange" },
          { "code": "1F4B2", "name": "heavy dollar sign" }
        ]
      },
      {
        "name": "other-symbol",
        "emojis": [
          { "code": "2695 FE0F", "name": "medical symbol" },
          { "code": "267B FE0F", "name": "recycling symbol" },
          { "code": "269C FE0F", "name": "fleur-de-lis" },
          { "code": "1F531", "name": "trident emblem" },
          { "code": "1F4DB", "name": "name badge" },
          { "code": "1F530", "name": "Japanese symbol for beginner" },
          { "code": "2B55", "name": "hollow red circle" },
          { "code": "2705", "name": "check mark button" },
          { "code": "2611 FE0F", "name": "check box with check" },
          { "code": "2714 FE0F", "name": "check mark" },
          { "code": "274C", "name": "cross mark" },
          { "code": "274E", "name": "cross mark button" },
          { "code": "27B0", "name": "curly loop" },
          { "code": "27BF", "name": "double curly loop" },
          { "code": "303D FE0F", "name": "part alternation mark" },
          { "code": "2733 FE0F", "name": "eight-spoked asterisk" },
          { "code": "2734 FE0F", "name": "eight-pointed star" },
          { "code": "2747 FE0F", "name": "sparkle" },
          { "code": "00A9 FE0F", "name": "copyright" },
          { "code": "00AE FE0F", "name": "registered" },
          { "code": "2122 FE0F", "name": "trade mark" },
          { "code": "1FADF", "name": "splatter" }
        ]
      },
      {
        "name": "keycap",
        "emojis": [
          { "code": "0023 FE0F 20E3", "name": "keycap: #" },
          { "code": "002A FE0F 20E3", "name": "keycap: *" },
          { "code": "0030 FE0F 20E3", "name": "keycap: 0" },
          { "code": "0031 FE0F 20E3", "name": "keycap: 1" },
          { "code": "0032 FE0F 20E3", "name": "keycap: 2" },
          { "code": "0033 FE0F 20E3", "name": "keycap: 3" },
          { "code": "0034 FE0F 20E3", "name": "keycap: 4" },
          { "code": "0035 FE0F 20E3", "name": "keycap: 5" },
          { "code": "0036 FE0F 20E3", "name": "keycap: 6" },
          { "code": "0037 FE0F 20E3", "name": "keycap: 7" },
          { "code": "0038 FE0F 20E3", "name": "keycap: 8" },
          { "code": "0039 FE0F 20E3", "name": "keycap: 9" },
          { "code": "1F51F", "name": "keycap: 10" }
        ]
      },
      {
        "name": "alphanum",
        "emojis": [
          { "code": "1F520", "name": "input latin uppercase" },
          { "code": "1F521", "name": "input latin lowercase" },
          { "code": "1F522", "name": "input numbers" },
          { "code": "1F523", "name": "input symbols" },
          { "code": "1F524", "name": "input latin letters" },
          { "code": "1F170 FE0F", "name": "A button (blood type)" },
          { "code": "1F18E", "name": "AB button (blood type)" },
          { "code": "1F171 FE0F", "name": "B button (blood type)" },
          { "code": "1F191", "name": "CL button" },
          { "code": "1F192", "name": "COOL button" },
          { "code": "1F193", "name": "FREE button" },
          { "code": "2139 FE0F", "name": "information" },
          { "code": "1F194", "name": "ID button" },
          { "code": "24C2 FE0F", "name": "circled M" },
          { "code": "1F195", "name": "NEW button" },
          { "code": "1F196", "name": "NG button" },
          { "code": "1F17E FE0F", "name": "O button (blood type)" },
          { "code": "1F197", "name": "OK button" },
          { "code": "1F17F FE0F", "name": "P button" },
          { "code": "1F198", "name": "SOS button" },
          { "code": "1F199", "name": "UP! button" },
          { "code": "1F19A", "name": "VS button" },
          { "code": "1F201", "name": "Japanese “here” button" },
          { "code": "1F202 FE0F", "name": "Japanese “service charge” button" },
          { "code": "1F237 FE0F", "name": "Japanese “monthly amount” button" },
          { "code": "1F236", "name": "Japanese “not free of charge” button" },
          { "code": "1F22F", "name": "Japanese “reserved” button" },
          { "code": "1F250", "name": "Japanese “bargain” button" },
          { "code": "1F239", "name": "Japanese “discount” button" },
          { "code": "1F21A", "name": "Japanese “free of charge” button" },
          { "code": "1F232", "name": "Japanese “prohibited” button" },
          { "code": "1F251", "name": "Japanese “acceptable” button" },
          { "code": "1F238", "name": "Japanese “application” button" },
          { "code": "1F234", "name": "Japanese “passing grade” button" },
          { "code": "1F233", "name": "Japanese “vacancy” button" },
          { "code": "3297 FE0F", "name": "Japanese “congratulations” button" },
          { "code": "3299 FE0F", "name": "Japanese “secret” button" },
          { "code": "1F23A", "name": "Japanese “open for business” button" },
          { "code": "1F235", "name": "Japanese “no vacancy” button" }
        ]
      },
      {
        "name": "geometric",
        "emojis": [
          { "code": "1F534", "name": "red circle" },
          { "code": "1F7E0", "name": "orange circle" },
          { "code": "1F7E1", "name": "yellow circle" },
          { "code": "1F7E2", "name": "green circle" },
          { "code": "1F535", "name": "blue circle" },
          { "code": "1F7E3", "name": "purple circle" },
          { "code": "1F7E4", "name": "brown circle" },
          { "code": "26AB", "name": "black circle" },
          { "code": "26AA", "name": "white circle" },
          { "code": "1F7E5", "name": "red square" },
          { "code": "1F7E7", "name": "orange square" },
          { "code": "1F7E8", "name": "yellow square" },
          { "code": "1F7E9", "name": "green square" },
          { "code": "1F7E6", "name": "blue square" },
          { "code": "1F7EA", "name": "purple square" },
          { "code": "1F7EB", "name": "brown square" },
          { "code": "2B1B", "name": "black large square" },
          { "code": "2B1C", "name": "white large square" },
          { "code": "25FC FE0F", "name": "black medium square" },
          { "code": "25FB FE0F", "name": "white medium square" },
          { "code": "25FE", "name": "black medium-small square" },
          { "code": "25FD", "name": "white medium-small square" },
          { "code": "25AA FE0F", "name": "black small square" },
          { "code": "25AB FE0F", "name": "white small square" },
          { "code": "1F536", "name": "large orange diamond" },
          { "code": "1F537", "name": "large blue diamond" },
          { "code": "1F538", "name": "small orange diamond" },
          { "code": "1F539", "name": "small blue diamond" },
          { "code": "1F53A", "name": "red triangle pointed up" },
          { "code": "1F53B", "name": "red triangle pointed down" },
          { "code": "1F4A0", "name": "diamond with a dot" },
          { "code": "1F518", "name": "radio button" },
          { "code": "1F533", "name": "white square button" },
          { "code": "1F532", "name": "black square button" }
        ]
      }
    ]
  },
  {
    "name": "Flags",
    "subGroups": [
      {
        "name": "flag",
        "emojis": [
          { "code": "1F3C1", "name": "chequered flag" },
          { "code": "1F6A9", "name": "triangular flag" },
          { "code": "1F38C", "name": "crossed flags" },
          { "code": "1F3F4", "name": "black flag" },
          { "code": "1F3F3 FE0F", "name": "white flag" },
          { "code": "1F3F3 FE0F 200D 1F308", "name": "rainbow flag" },
          { "code": "1F3F3 FE0F 200D 26A7 FE0F", "name": "transgender flag" },
          { "code": "1F3F4 200D 2620 FE0F", "name": "pirate flag" }
        ]
      },
      {
        "name": "country-flag",
        "emojis": [
          { "code": "1F1E6 1F1E8", "name": "flag: Ascension Island" },
          { "code": "1F1E6 1F1E9", "name": "flag: Andorra" },
          { "code": "1F1E6 1F1EA", "name": "flag: United Arab Emirates" },
          { "code": "1F1E6 1F1EB", "name": "flag: Afghanistan" },
          { "code": "1F1E6 1F1EC", "name": "flag: Antigua & Barbuda" },
          { "code": "1F1E6 1F1EE", "name": "flag: Anguilla" },
          { "code": "1F1E6 1F1F1", "name": "flag: Albania" },
          { "code": "1F1E6 1F1F2", "name": "flag: Armenia" },
          { "code": "1F1E6 1F1F4", "name": "flag: Angola" },
          { "code": "1F1E6 1F1F6", "name": "flag: Antarctica" },
          { "code": "1F1E6 1F1F7", "name": "flag: Argentina" },
          { "code": "1F1E6 1F1F8", "name": "flag: American Samoa" },
          { "code": "1F1E6 1F1F9", "name": "flag: Austria" },
          { "code": "1F1E6 1F1FA", "name": "flag: Australia" },
          { "code": "1F1E6 1F1FC", "name": "flag: Aruba" },
          { "code": "1F1E6 1F1FD", "name": "flag: Åland Islands" },
          { "code": "1F1E6 1F1FF", "name": "flag: Azerbaijan" },
          { "code": "1F1E7 1F1E6", "name": "flag: Bosnia & Herzegovina" },
          { "code": "1F1E7 1F1E7", "name": "flag: Barbados" },
          { "code": "1F1E7 1F1E9", "name": "flag: Bangladesh" },
          { "code": "1F1E7 1F1EA", "name": "flag: Belgium" },
          { "code": "1F1E7 1F1EB", "name": "flag: Burkina Faso" },
          { "code": "1F1E7 1F1EC", "name": "flag: Bulgaria" },
          { "code": "1F1E7 1F1ED", "name": "flag: Bahrain" },
          { "code": "1F1E7 1F1EE", "name": "flag: Burundi" },
          { "code": "1F1E7 1F1EF", "name": "flag: Benin" },
          { "code": "1F1E7 1F1F1", "name": "flag: St. Barthélemy" },
          { "code": "1F1E7 1F1F2", "name": "flag: Bermuda" },
          { "code": "1F1E7 1F1F3", "name": "flag: Brunei" },
          { "code": "1F1E7 1F1F4", "name": "flag: Bolivia" },
          { "code": "1F1E7 1F1F6", "name": "flag: Caribbean Netherlands" },
          { "code": "1F1E7 1F1F7", "name": "flag: Brazil" },
          { "code": "1F1E7 1F1F8", "name": "flag: Bahamas" },
          { "code": "1F1E7 1F1F9", "name": "flag: Bhutan" },
          { "code": "1F1E7 1F1FB", "name": "flag: Bouvet Island" },
          { "code": "1F1E7 1F1FC", "name": "flag: Botswana" },
          { "code": "1F1E7 1F1FE", "name": "flag: Belarus" },
          { "code": "1F1E7 1F1FF", "name": "flag: Belize" },
          { "code": "1F1E8 1F1E6", "name": "flag: Canada" },
          { "code": "1F1E8 1F1E8", "name": "flag: Cocos (Keeling) Islands" },
          { "code": "1F1E8 1F1E9", "name": "flag: Congo - Kinshasa" },
          { "code": "1F1E8 1F1EB", "name": "flag: Central African Republic" },
          { "code": "1F1E8 1F1EC", "name": "flag: Congo - Brazzaville" },
          { "code": "1F1E8 1F1ED", "name": "flag: Switzerland" },
          { "code": "1F1E8 1F1EE", "name": "flag: Côte d’Ivoire" },
          { "code": "1F1E8 1F1F0", "name": "flag: Cook Islands" },
          { "code": "1F1E8 1F1F1", "name": "flag: Chile" },
          { "code": "1F1E8 1F1F2", "name": "flag: Cameroon" },
          { "code": "1F1E8 1F1F3", "name": "flag: China" },
          { "code": "1F1E8 1F1F4", "name": "flag: Colombia" },
          { "code": "1F1E8 1F1F5", "name": "flag: Clipperton Island" },
          { "code": "1F1E8 1F1F6", "name": "flag: Sark" },
          { "code": "1F1E8 1F1F7", "name": "flag: Costa Rica" },
          { "code": "1F1E8 1F1FA", "name": "flag: Cuba" },
          { "code": "1F1E8 1F1FB", "name": "flag: Cape Verde" },
          { "code": "1F1E8 1F1FC", "name": "flag: Curaçao" },
          { "code": "1F1E8 1F1FD", "name": "flag: Christmas Island" },
          { "code": "1F1E8 1F1FE", "name": "flag: Cyprus" },
          { "code": "1F1E8 1F1FF", "name": "flag: Czechia" },
          { "code": "1F1E9 1F1EA", "name": "flag: Germany" },
          { "code": "1F1E9 1F1EC", "name": "flag: Diego Garcia" },
          { "code": "1F1E9 1F1EF", "name": "flag: Djibouti" },
          { "code": "1F1E9 1F1F0", "name": "flag: Denmark" },
          { "code": "1F1E9 1F1F2", "name": "flag: Dominica" },
          { "code": "1F1E9 1F1F4", "name": "flag: Dominican Republic" },
          { "code": "1F1E9 1F1FF", "name": "flag: Algeria" },
          { "code": "1F1EA 1F1E6", "name": "flag: Ceuta & Melilla" },
          { "code": "1F1EA 1F1E8", "name": "flag: Ecuador" },
          { "code": "1F1EA 1F1EA", "name": "flag: Estonia" },
          { "code": "1F1EA 1F1EC", "name": "flag: Egypt" },
          { "code": "1F1EA 1F1ED", "name": "flag: Western Sahara" },
          { "code": "1F1EA 1F1F7", "name": "flag: Eritrea" },
          { "code": "1F1EA 1F1F8", "name": "flag: Spain" },
          { "code": "1F1EA 1F1F9", "name": "flag: Ethiopia" },
          { "code": "1F1EA 1F1FA", "name": "flag: European Union" },
          { "code": "1F1EB 1F1EE", "name": "flag: Finland" },
          { "code": "1F1EB 1F1EF", "name": "flag: Fiji" },
          { "code": "1F1EB 1F1F0", "name": "flag: Falkland Islands" },
          { "code": "1F1EB 1F1F2", "name": "flag: Micronesia" },
          { "code": "1F1EB 1F1F4", "name": "flag: Faroe Islands" },
          { "code": "1F1EB 1F1F7", "name": "flag: France" },
          { "code": "1F1EC 1F1E6", "name": "flag: Gabon" },
          { "code": "1F1EC 1F1E7", "name": "flag: United Kingdom" },
          { "code": "1F1EC 1F1E9", "name": "flag: Grenada" },
          { "code": "1F1EC 1F1EA", "name": "flag: Georgia" },
          { "code": "1F1EC 1F1EB", "name": "flag: French Guiana" },
          { "code": "1F1EC 1F1EC", "name": "flag: Guernsey" },
          { "code": "1F1EC 1F1ED", "name": "flag: Ghana" },
          { "code": "1F1EC 1F1EE", "name": "flag: Gibraltar" },
          { "code": "1F1EC 1F1F1", "name": "flag: Greenland" },
          { "code": "1F1EC 1F1F2", "name": "flag: Gambia" },
          { "code": "1F1EC 1F1F3", "name": "flag: Guinea" },
          { "code": "1F1EC 1F1F5", "name": "flag: Guadeloupe" },
          { "code": "1F1EC 1F1F6", "name": "flag: Equatorial Guinea" },
          { "code": "1F1EC 1F1F7", "name": "flag: Greece" },
          { "code": "1F1EC 1F1F8", "name": "flag: South Georgia & South Sandwich Islands" },
          { "code": "1F1EC 1F1F9", "name": "flag: Guatemala" },
          { "code": "1F1EC 1F1FA", "name": "flag: Guam" },
          { "code": "1F1EC 1F1FC", "name": "flag: Guinea-Bissau" },
          { "code": "1F1EC 1F1FE", "name": "flag: Guyana" },
          { "code": "1F1ED 1F1F0", "name": "flag: Hong Kong SAR China" },
          { "code": "1F1ED 1F1F2", "name": "flag: Heard & McDonald Islands" },
          { "code": "1F1ED 1F1F3", "name": "flag: Honduras" },
          { "code": "1F1ED 1F1F7", "name": "flag: Croatia" },
          { "code": "1F1ED 1F1F9", "name": "flag: Haiti" },
          { "code": "1F1ED 1F1FA", "name": "flag: Hungary" },
          { "code": "1F1EE 1F1E8", "name": "flag: Canary Islands" },
          { "code": "1F1EE 1F1E9", "name": "flag: Indonesia" },
          { "code": "1F1EE 1F1EA", "name": "flag: Ireland" },
          { "code": "1F1EE 1F1F1", "name": "flag: Israel" },
          { "code": "1F1EE 1F1F2", "name": "flag: Isle of Man" },
          { "code": "1F1EE 1F1F3", "name": "flag: India" },
          { "code": "1F1EE 1F1F4", "name": "flag: British Indian Ocean Territory" },
          { "code": "1F1EE 1F1F6", "name": "flag: Iraq" },
          { "code": "1F1EE 1F1F7", "name": "flag: Iran" },
          { "code": "1F1EE 1F1F8", "name": "flag: Iceland" },
          { "code": "1F1EE 1F1F9", "name": "flag: Italy" },
          { "code": "1F1EF 1F1EA", "name": "flag: Jersey" },
          { "code": "1F1EF 1F1F2", "name": "flag: Jamaica" },
          { "code": "1F1EF 1F1F4", "name": "flag: Jordan" },
          { "code": "1F1EF 1F1F5", "name": "flag: Japan" },
          { "code": "1F1F0 1F1EA", "name": "flag: Kenya" },
          { "code": "1F1F0 1F1EC", "name": "flag: Kyrgyzstan" },
          { "code": "1F1F0 1F1ED", "name": "flag: Cambodia" },
          { "code": "1F1F0 1F1EE", "name": "flag: Kiribati" },
          { "code": "1F1F0 1F1F2", "name": "flag: Comoros" },
          { "code": "1F1F0 1F1F3", "name": "flag: St. Kitts & Nevis" },
          { "code": "1F1F0 1F1F5", "name": "flag: North Korea" },
          { "code": "1F1F0 1F1F7", "name": "flag: South Korea" },
          { "code": "1F1F0 1F1FC", "name": "flag: Kuwait" },
          { "code": "1F1F0 1F1FE", "name": "flag: Cayman Islands" },
          { "code": "1F1F0 1F1FF", "name": "flag: Kazakhstan" },
          { "code": "1F1F1 1F1E6", "name": "flag: Laos" },
          { "code": "1F1F1 1F1E7", "name": "flag: Lebanon" },
          { "code": "1F1F1 1F1E8", "name": "flag: St. Lucia" },
          { "code": "1F1F1 1F1EE", "name": "flag: Liechtenstein" },
          { "code": "1F1F1 1F1F0", "name": "flag: Sri Lanka" },
          { "code": "1F1F1 1F1F7", "name": "flag: Liberia" },
          { "code": "1F1F1 1F1F8", "name": "flag: Lesotho" },
          { "code": "1F1F1 1F1F9", "name": "flag: Lithuania" },
          { "code": "1F1F1 1F1FA", "name": "flag: Luxembourg" },
          { "code": "1F1F1 1F1FB", "name": "flag: Latvia" },
          { "code": "1F1F1 1F1FE", "name": "flag: Libya" },
          { "code": "1F1F2 1F1E6", "name": "flag: Morocco" },
          { "code": "1F1F2 1F1E8", "name": "flag: Monaco" },
          { "code": "1F1F2 1F1E9", "name": "flag: Moldova" },
          { "code": "1F1F2 1F1EA", "name": "flag: Montenegro" },
          { "code": "1F1F2 1F1EB", "name": "flag: St. Martin" },
          { "code": "1F1F2 1F1EC", "name": "flag: Madagascar" },
          { "code": "1F1F2 1F1ED", "name": "flag: Marshall Islands" },
          { "code": "1F1F2 1F1F0", "name": "flag: North Macedonia" },
          { "code": "1F1F2 1F1F1", "name": "flag: Mali" },
          { "code": "1F1F2 1F1F2", "name": "flag: Myanmar (Burma)" },
          { "code": "1F1F2 1F1F3", "name": "flag: Mongolia" },
          { "code": "1F1F2 1F1F4", "name": "flag: Macao SAR China" },
          { "code": "1F1F2 1F1F5", "name": "flag: Northern Mariana Islands" },
          { "code": "1F1F2 1F1F6", "name": "flag: Martinique" },
          { "code": "1F1F2 1F1F7", "name": "flag: Mauritania" },
          { "code": "1F1F2 1F1F8", "name": "flag: Montserrat" },
          { "code": "1F1F2 1F1F9", "name": "flag: Malta" },
          { "code": "1F1F2 1F1FA", "name": "flag: Mauritius" },
          { "code": "1F1F2 1F1FB", "name": "flag: Maldives" },
          { "code": "1F1F2 1F1FC", "name": "flag: Malawi" },
          { "code": "1F1F2 1F1FD", "name": "flag: Mexico" },
          { "code": "1F1F2 1F1FE", "name": "flag: Malaysia" },
          { "code": "1F1F2 1F1FF", "name": "flag: Mozambique" },
          { "code": "1F1F3 1F1E6", "name": "flag: Namibia" },
          { "code": "1F1F3 1F1E8", "name": "flag: New Caledonia" },
          { "code": "1F1F3 1F1EA", "name": "flag: Niger" },
          { "code": "1F1F3 1F1EB", "name": "flag: Norfolk Island" },
          { "code": "1F1F3 1F1EC", "name": "flag: Nigeria" },
          { "code": "1F1F3 1F1EE", "name": "flag: Nicaragua" },
          { "code": "1F1F3 1F1F1", "name": "flag: Netherlands" },
          { "code": "1F1F3 1F1F4", "name": "flag: Norway" },
          { "code": "1F1F3 1F1F5", "name": "flag: Nepal" },
          { "code": "1F1F3 1F1F7", "name": "flag: Nauru" },
          { "code": "1F1F3 1F1FA", "name": "flag: Niue" },
          { "code": "1F1F3 1F1FF", "name": "flag: New Zealand" },
          { "code": "1F1F4 1F1F2", "name": "flag: Oman" },
          { "code": "1F1F5 1F1E6", "name": "flag: Panama" },
          { "code": "1F1F5 1F1EA", "name": "flag: Peru" },
          { "code": "1F1F5 1F1EB", "name": "flag: French Polynesia" },
          { "code": "1F1F5 1F1EC", "name": "flag: Papua New Guinea" },
          { "code": "1F1F5 1F1ED", "name": "flag: Philippines" },
          { "code": "1F1F5 1F1F0", "name": "flag: Pakistan" },
          { "code": "1F1F5 1F1F1", "name": "flag: Poland" },
          { "code": "1F1F5 1F1F2", "name": "flag: St. Pierre & Miquelon" },
          { "code": "1F1F5 1F1F3", "name": "flag: Pitcairn Islands" },
          { "code": "1F1F5 1F1F7", "name": "flag: Puerto Rico" },
          { "code": "1F1F5 1F1F8", "name": "flag: Palestinian Territories" },
          { "code": "1F1F5 1F1F9", "name": "flag: Portugal" },
          { "code": "1F1F5 1F1FC", "name": "flag: Palau" },
          { "code": "1F1F5 1F1FE", "name": "flag: Paraguay" },
          { "code": "1F1F6 1F1E6", "name": "flag: Qatar" },
          { "code": "1F1F7 1F1EA", "name": "flag: Réunion" },
          { "code": "1F1F7 1F1F4", "name": "flag: Romania" },
          { "code": "1F1F7 1F1F8", "name": "flag: Serbia" },
          { "code": "1F1F7 1F1FA", "name": "flag: Russia" },
          { "code": "1F1F7 1F1FC", "name": "flag: Rwanda" },
          { "code": "1F1F8 1F1E6", "name": "flag: Saudi Arabia" },
          { "code": "1F1F8 1F1E7", "name": "flag: Solomon Islands" },
          { "code": "1F1F8 1F1E8", "name": "flag: Seychelles" },
          { "code": "1F1F8 1F1E9", "name": "flag: Sudan" },
          { "code": "1F1F8 1F1EA", "name": "flag: Sweden" },
          { "code": "1F1F8 1F1EC", "name": "flag: Singapore" },
          { "code": "1F1F8 1F1ED", "name": "flag: St. Helena" },
          { "code": "1F1F8 1F1EE", "name": "flag: Slovenia" },
          { "code": "1F1F8 1F1EF", "name": "flag: Svalbard & Jan Mayen" },
          { "code": "1F1F8 1F1F0", "name": "flag: Slovakia" },
          { "code": "1F1F8 1F1F1", "name": "flag: Sierra Leone" },
          { "code": "1F1F8 1F1F2", "name": "flag: San Marino" },
          { "code": "1F1F8 1F1F3", "name": "flag: Senegal" },
          { "code": "1F1F8 1F1F4", "name": "flag: Somalia" },
          { "code": "1F1F8 1F1F7", "name": "flag: Suriname" },
          { "code": "1F1F8 1F1F8", "name": "flag: South Sudan" },
          { "code": "1F1F8 1F1F9", "name": "flag: São Tomé & Príncipe" },
          { "code": "1F1F8 1F1FB", "name": "flag: El Salvador" },
          { "code": "1F1F8 1F1FD", "name": "flag: Sint Maarten" },
          { "code": "1F1F8 1F1FE", "name": "flag: Syria" },
          { "code": "1F1F8 1F1FF", "name": "flag: Eswatini" },
          { "code": "1F1F9 1F1E6", "name": "flag: Tristan da Cunha" },
          { "code": "1F1F9 1F1E8", "name": "flag: Turks & Caicos Islands" },
          { "code": "1F1F9 1F1E9", "name": "flag: Chad" },
          { "code": "1F1F9 1F1EB", "name": "flag: French Southern Territories" },
          { "code": "1F1F9 1F1EC", "name": "flag: Togo" },
          { "code": "1F1F9 1F1ED", "name": "flag: Thailand" },
          { "code": "1F1F9 1F1EF", "name": "flag: Tajikistan" },
          { "code": "1F1F9 1F1F0", "name": "flag: Tokelau" },
          { "code": "1F1F9 1F1F1", "name": "flag: Timor-Leste" },
          { "code": "1F1F9 1F1F2", "name": "flag: Turkmenistan" },
          { "code": "1F1F9 1F1F3", "name": "flag: Tunisia" },
          { "code": "1F1F9 1F1F4", "name": "flag: Tonga" },
          { "code": "1F1F9 1F1F7", "name": "flag: Türkiye" },
          { "code": "1F1F9 1F1F9", "name": "flag: Trinidad & Tobago" },
          { "code": "1F1F9 1F1FB", "name": "flag: Tuvalu" },
          { "code": "1F1F9 1F1FC", "name": "flag: Taiwan" },
          { "code": "1F1F9 1F1FF", "name": "flag: Tanzania" },
          { "code": "1F1FA 1F1E6", "name": "flag: Ukraine" },
          { "code": "1F1FA 1F1EC", "name": "flag: Uganda" },
          { "code": "1F1FA 1F1F2", "name": "flag: U.S. Outlying Islands" },
          { "code": "1F1FA 1F1F3", "name": "flag: United Nations" },
          { "code": "1F1FA 1F1F8", "name": "flag: United States" },
          { "code": "1F1FA 1F1FE", "name": "flag: Uruguay" },
          { "code": "1F1FA 1F1FF", "name": "flag: Uzbekistan" },
          { "code": "1F1FB 1F1E6", "name": "flag: Vatican City" },
          { "code": "1F1FB 1F1E8", "name": "flag: St. Vincent & Grenadines" },
          { "code": "1F1FB 1F1EA", "name": "flag: Venezuela" },
          { "code": "1F1FB 1F1EC", "name": "flag: British Virgin Islands" },
          { "code": "1F1FB 1F1EE", "name": "flag: U.S. Virgin Islands" },
          { "code": "1F1FB 1F1F3", "name": "flag: Vietnam" },
          { "code": "1F1FB 1F1FA", "name": "flag: Vanuatu" },
          { "code": "1F1FC 1F1EB", "name": "flag: Wallis & Futuna" },
          { "code": "1F1FC 1F1F8", "name": "flag: Samoa" },
          { "code": "1F1FD 1F1F0", "name": "flag: Kosovo" },
          { "code": "1F1FE 1F1EA", "name": "flag: Yemen" },
          { "code": "1F1FE 1F1F9", "name": "flag: Mayotte" },
          { "code": "1F1FF 1F1E6", "name": "flag: South Africa" },
          { "code": "1F1FF 1F1F2", "name": "flag: Zambia" },
          { "code": "1F1FF 1F1FC", "name": "flag: Zimbabwe" }
        ]
      },
      {
        "name": "subdivision-flag",
        "emojis": [
          { "code": "1F3F4 E0067 E0062 E0065 E006E E0067 E007F", "name": "flag: England" },
          { "code": "1F3F4 E0067 E0062 E0073 E0063 E0074 E007F", "name": "flag: Scotland" },
          { "code": "1F3F4 E0067 E0062 E0077 E006C E0073 E007F", "name": "flag: Wales" }
        ]
      }
    ]
  }
]
